import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AccountDetailInfo = {
  __typename?: 'AccountDetailInfo';
  AboutRuler1?: Maybe<Scalars['Int']['output']>;
  AboutRuler2?: Maybe<Scalars['Int']['output']>;
  AboutRuler3?: Maybe<Scalars['Int']['output']>;
  BuildingNameAndRoomNumber?: Maybe<Scalars['String']['output']>;
  CityCountry?: Maybe<Scalars['String']['output']>;
  ConfirmResponsibility?: Maybe<Scalars['Boolean']['output']>;
  ContactFaxNumber?: Maybe<Scalars['String']['output']>;
  ContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  CorporateAddressConfirm?: Maybe<Scalars['Boolean']['output']>;
  CorporateCapital?: Maybe<Scalars['Float']['output']>;
  CorporateEstablishmentDate?: Maybe<Scalars['String']['output']>;
  CorporateHomepage?: Maybe<Scalars['String']['output']>;
  CorporateMainBusinessContent?: Maybe<Scalars['Int']['output']>;
  CorporateMainBusinessContentOtherText?: Maybe<Scalars['String']['output']>;
  CorporateNumber?: Maybe<Scalars['String']['output']>;
  CorporateNumberOfEmployees?: Maybe<Scalars['Float']['output']>;
  CorporateOtherBusinessContent?: Maybe<Scalars['Int']['output']>;
  CorporateOtherBusinessContentOtherText?: Maybe<Scalars['String']['output']>;
  CorporateSettlementDay?: Maybe<Scalars['Int']['output']>;
  CorporateSettlementMonth?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  DealerBirthDay?: Maybe<Scalars['String']['output']>;
  DealerBuildingNameAndRoomNumber?: Maybe<Scalars['String']['output']>;
  DealerCityCountry?: Maybe<Scalars['String']['output']>;
  DealerDepartment?: Maybe<Scalars['String']['output']>;
  DealerFirstName?: Maybe<Scalars['String']['output']>;
  DealerFirstNameKana?: Maybe<Scalars['String']['output']>;
  DealerLastName?: Maybe<Scalars['String']['output']>;
  DealerLastNameKana?: Maybe<Scalars['String']['output']>;
  DealerMailAddress?: Maybe<Scalars['String']['output']>;
  DealerMobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  DealerOtherDepartment?: Maybe<Scalars['String']['output']>;
  DealerPosition?: Maybe<Scalars['String']['output']>;
  DealerPostCode?: Maybe<Scalars['String']['output']>;
  DealerPrefecture?: Maybe<Scalars['String']['output']>;
  DealerTownStreetAddress?: Maybe<Scalars['String']['output']>;
  DomesticRealEstatePurpose?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  DomesticRealEstatePurposeOtherText?: Maybe<Scalars['String']['output']>;
  ElectronicDocumentAgreement?: Maybe<Scalars['Boolean']['output']>;
  Fatca?: Maybe<Scalars['Int']['output']>;
  FatcaOtherText?: Maybe<Scalars['String']['output']>;
  Furigana?: Maybe<Scalars['String']['output']>;
  ImportantPublicWorker?: Maybe<Scalars['Int']['output']>;
  ImportantPublicWorkerOtherReason?: Maybe<Scalars['String']['output']>;
  InvestorCategoryInfo?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  InvoiceNumber?: Maybe<Scalars['String']['output']>;
  LeaseFundPurpose?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  LeaseFundPurposeOtherText?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  Occupation?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  OccupationOtherText?: Maybe<Scalars['String']['output']>;
  OverseasRealEstatePurpose?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  OverseasRealEstatePurposeOtherText?: Maybe<Scalars['String']['output']>;
  PersonalMainBusinessContent?: Maybe<Scalars['Int']['output']>;
  PersonalMainBusinessContentOtherText?: Maybe<Scalars['String']['output']>;
  PersonalOtherBusinessContent?: Maybe<Scalars['Int']['output']>;
  PersonalOtherBusinessContentOtherText?: Maybe<Scalars['String']['output']>;
  PostCode?: Maybe<Scalars['String']['output']>;
  Prefecture?: Maybe<Scalars['String']['output']>;
  RegisteredBuildingNameAndRoomNumber?: Maybe<Scalars['String']['output']>;
  RegisteredCityCountry?: Maybe<Scalars['String']['output']>;
  RegisteredPostCode?: Maybe<Scalars['String']['output']>;
  RegisteredPrefecture?: Maybe<Scalars['String']['output']>;
  RegisteredTownStreetAddress?: Maybe<Scalars['String']['output']>;
  RepresentAndDealerAreSame?: Maybe<Scalars['Boolean']['output']>;
  RepresentBirthDay?: Maybe<Scalars['String']['output']>;
  RepresentBuildingNameAndRoomNumber?: Maybe<Scalars['String']['output']>;
  RepresentCityCountry?: Maybe<Scalars['String']['output']>;
  RepresentFirstName?: Maybe<Scalars['String']['output']>;
  RepresentFirstNameKana?: Maybe<Scalars['String']['output']>;
  RepresentLastName?: Maybe<Scalars['String']['output']>;
  RepresentLastNameKana?: Maybe<Scalars['String']['output']>;
  RepresentMailAddress?: Maybe<Scalars['String']['output']>;
  RepresentMobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  RepresentPosition?: Maybe<Scalars['String']['output']>;
  RepresentPostCode?: Maybe<Scalars['String']['output']>;
  RepresentPrefecture?: Maybe<Scalars['String']['output']>;
  RepresentTownStreetAddress?: Maybe<Scalars['String']['output']>;
  Ruler1BirthDay?: Maybe<Scalars['String']['output']>;
  Ruler1BuildingNameAndRoomNumber?: Maybe<Scalars['String']['output']>;
  Ruler1CityCountry?: Maybe<Scalars['String']['output']>;
  Ruler1ImportantPublicWorker?: Maybe<Scalars['Boolean']['output']>;
  Ruler1MailAddress?: Maybe<Scalars['String']['output']>;
  Ruler1Name?: Maybe<Scalars['String']['output']>;
  Ruler1PostCode?: Maybe<Scalars['String']['output']>;
  Ruler1Prefecture?: Maybe<Scalars['String']['output']>;
  Ruler1Relationship?: Maybe<Scalars['Int']['output']>;
  Ruler1TownStreetAddress?: Maybe<Scalars['String']['output']>;
  Ruler2BirthDay?: Maybe<Scalars['String']['output']>;
  Ruler2BuildingNameAndRoomNumber?: Maybe<Scalars['String']['output']>;
  Ruler2CityCountry?: Maybe<Scalars['String']['output']>;
  Ruler2ImportantPublicWorker?: Maybe<Scalars['Boolean']['output']>;
  Ruler2MailAddress?: Maybe<Scalars['String']['output']>;
  Ruler2Name?: Maybe<Scalars['String']['output']>;
  Ruler2PostCode?: Maybe<Scalars['String']['output']>;
  Ruler2Prefecture?: Maybe<Scalars['String']['output']>;
  Ruler2Relationship?: Maybe<Scalars['Int']['output']>;
  Ruler2TownStreetAddress?: Maybe<Scalars['String']['output']>;
  Ruler3BirthDay?: Maybe<Scalars['String']['output']>;
  Ruler3BuildingNameAndRoomNumber?: Maybe<Scalars['String']['output']>;
  Ruler3CityCountry?: Maybe<Scalars['String']['output']>;
  Ruler3ImportantPublicWorker?: Maybe<Scalars['Boolean']['output']>;
  Ruler3MailAddress?: Maybe<Scalars['String']['output']>;
  Ruler3Name?: Maybe<Scalars['String']['output']>;
  Ruler3PostCode?: Maybe<Scalars['String']['output']>;
  Ruler3Prefecture?: Maybe<Scalars['String']['output']>;
  Ruler3Relationship?: Maybe<Scalars['Int']['output']>;
  Ruler3TownStreetAddress?: Maybe<Scalars['String']['output']>;
  TownStreetAddress?: Maybe<Scalars['String']['output']>;
  TransferAccountHolderName?: Maybe<Scalars['String']['output']>;
  TransferAccountNumber?: Maybe<Scalars['String']['output']>;
  TransferAccountType?: Maybe<Scalars['Int']['output']>;
  TransferBankName?: Maybe<Scalars['String']['output']>;
  TransferBranchName?: Maybe<Scalars['String']['output']>;
  TwoFactorAuthenticationType?: Maybe<Scalars['Int']['output']>;
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  Account: Scalars['String']['output'];
  AccountType?: Maybe<Scalars['Int']['output']>;
  ApplicationStatus?: Maybe<ApplicationStatusInfo>;
  Branch: Scalars['String']['output'];
  ChangedPassword?: Maybe<Scalars['Boolean']['output']>;
  Compatible?: Maybe<CompatibleInfo>;
  IsElderly?: Maybe<Scalars['Boolean']['output']>;
  IsInvested: Scalars['Boolean']['output'];
  KFFatca?: Maybe<Scalars['Boolean']['output']>;
  KFW8BenE?: Maybe<Scalars['Boolean']['output']>;
  LastLoginDateTime?: Maybe<Scalars['String']['output']>;
  SendSMSMessage?: Maybe<Scalars['String']['output']>;
};

export type AddSubUserParam = {
  MailAddress: Scalars['String']['input'];
  PhoneNumber: Scalars['String']['input'];
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  CityCountry?: Maybe<Scalars['String']['output']>;
  Prefecture?: Maybe<Scalars['String']['output']>;
  TownStreetAddress?: Maybe<Scalars['String']['output']>;
};

export type AdvanceQuestionParam = {
  CorporateAccount?: InputMaybe<CorporateAdvanceQuestionParam>;
  PersonalAccount?: InputMaybe<PersonalAdvanceQuestionParam>;
};

export type AdvanceQuestionValue = {
  __typename?: 'AdvanceQuestionValue';
  AdvanceCountryOfResidence?: Maybe<Scalars['Boolean']['output']>;
  AdvanceNationality?: Maybe<Scalars['Boolean']['output']>;
  Birthdate?: Maybe<Scalars['String']['output']>;
  CanTakePicture: Scalars['Boolean']['output'];
  DealerMailAddress: Scalars['String']['output'];
  HaveEKYCDocument: Scalars['Boolean']['output'];
  RepresentAndDealerAreSame?: Maybe<Scalars['Boolean']['output']>;
};

export type AgreeDisclosureStatementParam = {
  Type: Scalars['Int']['input'];
};

export type AgreeDocumentParam = {
  Types: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type AgreementDocumentInfo = {
  __typename?: 'AgreementDocumentInfo';
  ChangeDetailsURL: Scalars['String']['output'];
  ComparisonTableURL: Scalars['String']['output'];
  Read: Scalars['Boolean']['output'];
  TermsAndConditionsURL: Scalars['String']['output'];
  Type: Scalars['Int']['output'];
};

export type AgreementDocumentList = {
  __typename?: 'AgreementDocumentList';
  Data?: Maybe<Array<Maybe<AgreementDocumentInfo>>>;
};

export type AnswerCompatibilityParam = {
  CorporateDomesticRealEstate?: InputMaybe<CorporateDomesticRealEstateParam>;
  LeaseFund?: InputMaybe<LeaseFundParam>;
  OverseasRealEstate?: InputMaybe<OverseasRealEstateParam>;
  PersonalDomesticRealEstate?: InputMaybe<PersonalDomesticRealEstateParam>;
};

export type AnswerRecorderParam = {
  BusinessContent?: InputMaybe<Scalars['Int']['input']>;
  BusinessContentOther?: InputMaybe<Scalars['String']['input']>;
  Fatca?: InputMaybe<Scalars['Int']['input']>;
  Nffe?: InputMaybe<Scalars['Int']['input']>;
  Type: Scalars['Int']['input'];
  W8BenE?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicationDates = {
  Date1: Scalars['String']['input'];
  Date2: Scalars['String']['input'];
  Date3: Scalars['String']['input'];
  Time1: Scalars['String']['input'];
  Time2: Scalars['String']['input'];
  Time3: Scalars['String']['input'];
};

export type ApplicationInfo = {
  __typename?: 'ApplicationInfo';
  ApplicationAmount: Scalars['Float']['output'];
  ApplicationDate: Scalars['String']['output'];
  AssetType: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Linkable: Scalars['Boolean']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  SymbolShortName: Scalars['String']['output'];
  Unit: Scalars['String']['output'];
};

export type ApplicationList = {
  __typename?: 'ApplicationList';
  Data?: Maybe<Array<Maybe<ApplicationInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type ApplicationStatusInfo = {
  __typename?: 'ApplicationStatusInfo';
  HasAnsweredDividendAccount: Scalars['Boolean']['output'];
  HasAnsweredInvoiceNumber: Scalars['Boolean']['output'];
  HasValidFatcaAnswer?: Maybe<Scalars['Boolean']['output']>;
  HasValidPEPsAnswer: Scalars['Boolean']['output'];
};

export type ApplySymbolParam = {
  Amount: Scalars['Float']['input'];
  ApplicationID?: InputMaybe<Scalars['String']['input']>;
  ApplicationStartDate: Scalars['String']['input'];
  AssetType: Scalars['Int']['input'];
  ClientRequestId?: InputMaybe<Scalars['String']['input']>;
  DesiredApplicationDates?: InputMaybe<ApplicationDates>;
  IntroductionConfirmation?: InputMaybe<Scalars['Int']['input']>;
  RequestType: Scalars['Int']['input'];
  ResaleFlag?: InputMaybe<Scalars['Boolean']['input']>;
  Symbol: Scalars['String']['input'];
  TransferDate?: InputMaybe<Scalars['String']['input']>;
};

export type ApplySymbolResult = {
  __typename?: 'ApplySymbolResult';
  Code: Scalars['Int']['output'];
  ID?: Maybe<Scalars['String']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  PDFData?: Maybe<Scalars['String']['output']>;
};

export type BrokerInfo = {
  __typename?: 'BrokerInfo';
  BranchCode?: Maybe<Scalars['String']['output']>;
  BranchName?: Maybe<Scalars['String']['output']>;
  BrokerCode?: Maybe<Scalars['String']['output']>;
  BrokerName?: Maybe<Scalars['String']['output']>;
};

export type BrokerList = {
  __typename?: 'BrokerList';
  Data?: Maybe<Array<Maybe<BrokerInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type ChangeAccountInfoParam = {
  AboutRuler1?: InputMaybe<Scalars['Int']['input']>;
  AboutRuler2?: InputMaybe<Scalars['Int']['input']>;
  AboutRuler3?: InputMaybe<Scalars['Int']['input']>;
  BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  CanTakePicture?: InputMaybe<Scalars['Boolean']['input']>;
  CityCountry?: InputMaybe<Scalars['String']['input']>;
  ConfirmResponsibility?: InputMaybe<Scalars['Boolean']['input']>;
  ConsentDate?: InputMaybe<Scalars['String']['input']>;
  ContactFaxNumber?: InputMaybe<Scalars['String']['input']>;
  ContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  CorporateAddressConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  CorporateCapital?: InputMaybe<Scalars['Float']['input']>;
  CorporateEstablishmentDate?: InputMaybe<Scalars['String']['input']>;
  CorporateHomepage?: InputMaybe<Scalars['String']['input']>;
  CorporateMainBusinessContent?: InputMaybe<Scalars['Int']['input']>;
  CorporateMainBusinessContentOtherText?: InputMaybe<Scalars['String']['input']>;
  CorporateNumber?: InputMaybe<Scalars['String']['input']>;
  CorporateNumberOfEmployees?: InputMaybe<Scalars['Float']['input']>;
  CorporateSettlementDay?: InputMaybe<Scalars['Int']['input']>;
  CorporateSettlementMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  DealerBirthDay?: InputMaybe<Scalars['String']['input']>;
  DealerBuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  DealerCityCountry?: InputMaybe<Scalars['String']['input']>;
  DealerDepartment?: InputMaybe<Scalars['String']['input']>;
  DealerFirstName?: InputMaybe<Scalars['String']['input']>;
  DealerFirstNameKana?: InputMaybe<Scalars['String']['input']>;
  DealerLastName?: InputMaybe<Scalars['String']['input']>;
  DealerLastNameKana?: InputMaybe<Scalars['String']['input']>;
  DealerMailAddress?: InputMaybe<Scalars['String']['input']>;
  DealerMobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  DealerOtherDepartment?: InputMaybe<Scalars['String']['input']>;
  DealerPosition?: InputMaybe<Scalars['String']['input']>;
  DealerPostCode?: InputMaybe<Scalars['String']['input']>;
  DealerPrefecture?: InputMaybe<Scalars['String']['input']>;
  DealerTownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  DomesticRealEstatePurpose?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  DomesticRealEstatePurposeOtherText?: InputMaybe<Scalars['String']['input']>;
  Fatca?: InputMaybe<Scalars['Int']['input']>;
  FatcaOtherText?: InputMaybe<Scalars['String']['input']>;
  Furigana?: InputMaybe<Scalars['String']['input']>;
  HasNoInvoiceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  HaveEKYCDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ImportantPublicWorker?: InputMaybe<Scalars['Int']['input']>;
  ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  InvestorCategoryInfo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  InvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  LeaseFundPurpose?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  LeaseFundPurposeOtherText?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Occupation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  OccupationOtherText?: InputMaybe<Scalars['String']['input']>;
  OverseasRealEstatePurpose?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  OverseasRealEstatePurposeOtherText?: InputMaybe<Scalars['String']['input']>;
  PersonalMainBusinessContent?: InputMaybe<Scalars['Int']['input']>;
  PersonalMainBusinessContentOtherText?: InputMaybe<Scalars['String']['input']>;
  PersonalOtherBusinessContent?: InputMaybe<Scalars['Int']['input']>;
  PersonalOtherBusinessContentOtherText?: InputMaybe<Scalars['String']['input']>;
  PostCode?: InputMaybe<Scalars['String']['input']>;
  Prefecture?: InputMaybe<Scalars['String']['input']>;
  RegisteredBuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  RegisteredCityCountry?: InputMaybe<Scalars['String']['input']>;
  RegisteredPostCode?: InputMaybe<Scalars['String']['input']>;
  RegisteredPrefecture?: InputMaybe<Scalars['String']['input']>;
  RegisteredTownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  RepresentBirthDay?: InputMaybe<Scalars['String']['input']>;
  RepresentBuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  RepresentCityCountry?: InputMaybe<Scalars['String']['input']>;
  RepresentFirstName?: InputMaybe<Scalars['String']['input']>;
  RepresentFirstNameKana?: InputMaybe<Scalars['String']['input']>;
  RepresentLastName?: InputMaybe<Scalars['String']['input']>;
  RepresentLastNameKana?: InputMaybe<Scalars['String']['input']>;
  RepresentMailAddress?: InputMaybe<Scalars['String']['input']>;
  RepresentMobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  RepresentPosition?: InputMaybe<Scalars['String']['input']>;
  RepresentPostCode?: InputMaybe<Scalars['String']['input']>;
  RepresentPrefecture?: InputMaybe<Scalars['String']['input']>;
  RepresentTownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler1BirthDay?: InputMaybe<Scalars['String']['input']>;
  Ruler1BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  Ruler1CityCountry?: InputMaybe<Scalars['String']['input']>;
  Ruler1ImportantPublicWorker?: InputMaybe<Scalars['Boolean']['input']>;
  Ruler1ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  Ruler1MailAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler1Name?: InputMaybe<Scalars['String']['input']>;
  Ruler1PostCode?: InputMaybe<Scalars['String']['input']>;
  Ruler1Prefecture?: InputMaybe<Scalars['String']['input']>;
  Ruler1Relationship?: InputMaybe<Scalars['Int']['input']>;
  Ruler1TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler2BirthDay?: InputMaybe<Scalars['String']['input']>;
  Ruler2BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  Ruler2CityCountry?: InputMaybe<Scalars['String']['input']>;
  Ruler2ImportantPublicWorker?: InputMaybe<Scalars['Boolean']['input']>;
  Ruler2ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  Ruler2MailAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler2Name?: InputMaybe<Scalars['String']['input']>;
  Ruler2PostCode?: InputMaybe<Scalars['String']['input']>;
  Ruler2Prefecture?: InputMaybe<Scalars['String']['input']>;
  Ruler2Relationship?: InputMaybe<Scalars['Int']['input']>;
  Ruler2TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler3BirthDay?: InputMaybe<Scalars['String']['input']>;
  Ruler3BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  Ruler3CityCountry?: InputMaybe<Scalars['String']['input']>;
  Ruler3ImportantPublicWorker?: InputMaybe<Scalars['Boolean']['input']>;
  Ruler3ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  Ruler3MailAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler3Name?: InputMaybe<Scalars['String']['input']>;
  Ruler3PostCode?: InputMaybe<Scalars['String']['input']>;
  Ruler3Prefecture?: InputMaybe<Scalars['String']['input']>;
  Ruler3Relationship?: InputMaybe<Scalars['Int']['input']>;
  Ruler3TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  TransferAccountHolderName?: InputMaybe<Scalars['String']['input']>;
  TransferAccountNumber?: InputMaybe<Scalars['String']['input']>;
  TransferAccountType?: InputMaybe<Scalars['Int']['input']>;
  TransferBankName?: InputMaybe<Scalars['String']['input']>;
  TransferBranchName?: InputMaybe<Scalars['String']['input']>;
  TwoFactorAuthenticationType?: InputMaybe<Scalars['Int']['input']>;
};

export type ChangeDomesticRealEstateApplicationParam = {
  Fatca?: InputMaybe<Scalars['Int']['input']>;
  HasNoInvoiceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  InvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  TransferAccountHolderName?: InputMaybe<Scalars['String']['input']>;
  TransferAccountNumber?: InputMaybe<Scalars['String']['input']>;
  TransferAccountType?: InputMaybe<Scalars['Int']['input']>;
  TransferBankName?: InputMaybe<Scalars['String']['input']>;
  TransferBranchName?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePasswordParam = {
  CurrentPassword: Scalars['String']['input'];
  NewPassword: Scalars['String']['input'];
};

export type Compatibility = {
  __typename?: 'Compatibility';
  DomesticRealEstateAnswer?: Maybe<DomesticRealEstateAnswerInfo>;
  LeaseFundAnswer?: Maybe<LeaseFundAnswerInfo>;
  OverseasRealEstateAnswer?: Maybe<OverseasRealEstateAnswerInfo>;
};

export type CompatibleInfo = {
  __typename?: 'CompatibleInfo';
  DomesticRealEstate?: Maybe<Scalars['Boolean']['output']>;
  LeaseFund?: Maybe<Scalars['Boolean']['output']>;
  OverseasRealEstate?: Maybe<Scalars['Boolean']['output']>;
};

export type ContractDetailInfo = {
  __typename?: 'ContractDetailInfo';
  AccruedInterest?: Maybe<Scalars['Float']['output']>;
  ApplicationAmount: Scalars['Float']['output'];
  AssignmentAgreementDocumentInfo?: Maybe<IssuanceDocumentFileInfo>;
  ContractAgreementDocumentData: Scalars['String']['output'];
  ContractAgreementDocumentInfo?: Maybe<IssuanceDocumentFileInfo>;
  ExpensesTotal?: Maybe<Scalars['Float']['output']>;
  PayeeBankAccount: Scalars['String']['output'];
  PayeeBankAccountHolderName: Scalars['String']['output'];
  PayeeBankAccountHolderNameKana: Scalars['String']['output'];
  PayeeBankAccountTypeName: Scalars['String']['output'];
  PayeeBankBranchName: Scalars['String']['output'];
  PayeeBankName: Scalars['String']['output'];
  PaymentDate: Scalars['String']['output'];
  ProductType: Scalars['Int']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  TotalTransferFee: Scalars['Float']['output'];
  TransferConsentDocumentInfo?: Maybe<IssuanceDocumentFileInfo>;
  TransferRequestFormDocumentInfo?: Maybe<IssuanceDocumentFileInfo>;
};

export type ContractInfo = {
  __typename?: 'ContractInfo';
  Code: Scalars['Int']['output'];
  Details?: Maybe<ContractDetailInfo>;
  Message?: Maybe<Scalars['String']['output']>;
};

export type CorporateAccountParam = {
  AboutRuler1?: InputMaybe<Scalars['Int']['input']>;
  AboutRuler2?: InputMaybe<Scalars['Int']['input']>;
  AboutRuler3?: InputMaybe<Scalars['Int']['input']>;
  CanTakePicture?: InputMaybe<Scalars['Boolean']['input']>;
  ConfirmResponsibility?: InputMaybe<Scalars['Boolean']['input']>;
  ConsentDate?: InputMaybe<Scalars['String']['input']>;
  ContactFaxNumber?: InputMaybe<Scalars['String']['input']>;
  ContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  CorporateAddressConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  CorporateBuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  CorporateCapital?: InputMaybe<Scalars['Float']['input']>;
  CorporateCityCountry?: InputMaybe<Scalars['String']['input']>;
  CorporateEstablishmentDate?: InputMaybe<Scalars['String']['input']>;
  CorporateFurigana?: InputMaybe<Scalars['String']['input']>;
  CorporateHomepage?: InputMaybe<Scalars['String']['input']>;
  CorporateMainBusinessContent?: InputMaybe<Scalars['Int']['input']>;
  CorporateMainBusinessContentOtherText?: InputMaybe<Scalars['String']['input']>;
  CorporateName?: InputMaybe<Scalars['String']['input']>;
  CorporateNumber?: InputMaybe<Scalars['String']['input']>;
  CorporateNumberOfEmployees?: InputMaybe<Scalars['Float']['input']>;
  CorporateOtherBusinessContent?: InputMaybe<Scalars['Int']['input']>;
  CorporateOtherBusinessContentOtherText?: InputMaybe<Scalars['String']['input']>;
  CorporatePostCode?: InputMaybe<Scalars['String']['input']>;
  CorporatePrefecture?: InputMaybe<Scalars['String']['input']>;
  CorporateSettlementDay?: InputMaybe<Scalars['Int']['input']>;
  CorporateSettlementMonth?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  CorporateTownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  DealerBirthDay?: InputMaybe<Scalars['String']['input']>;
  DealerBuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  DealerCityCountry?: InputMaybe<Scalars['String']['input']>;
  DealerDepartment?: InputMaybe<Scalars['String']['input']>;
  DealerFirstName?: InputMaybe<Scalars['String']['input']>;
  DealerFirstNameKana?: InputMaybe<Scalars['String']['input']>;
  DealerLastName?: InputMaybe<Scalars['String']['input']>;
  DealerLastNameKana?: InputMaybe<Scalars['String']['input']>;
  DealerMailAddress?: InputMaybe<Scalars['String']['input']>;
  DealerMobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  DealerOtherDepartment?: InputMaybe<Scalars['String']['input']>;
  DealerPosition?: InputMaybe<Scalars['String']['input']>;
  DealerPostCode?: InputMaybe<Scalars['String']['input']>;
  DealerPrefecture?: InputMaybe<Scalars['String']['input']>;
  DealerTownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  DomesticRealEstatePurpose?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  DomesticRealEstatePurposeOtherText?: InputMaybe<Scalars['String']['input']>;
  DownloadGeneralInvestorPdf?: InputMaybe<Scalars['Boolean']['input']>;
  ElectronicDocumentAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  ElectronicDocumentAgreementDateTime?: InputMaybe<Scalars['String']['input']>;
  HaveEKYCDocument?: InputMaybe<Scalars['Boolean']['input']>;
  InvestorCategory?: InputMaybe<Scalars['String']['input']>;
  InvestorCategoryInfo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  LeaseFundPurpose?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  LeaseFundPurposeOtherText?: InputMaybe<Scalars['String']['input']>;
  OverseasRealEstatePurpose?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  OverseasRealEstatePurposeOtherText?: InputMaybe<Scalars['String']['input']>;
  PrivacyProtectionAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  RegisteredCorporateBuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  RegisteredCorporateCityCountry?: InputMaybe<Scalars['String']['input']>;
  RegisteredCorporatePostCode?: InputMaybe<Scalars['String']['input']>;
  RegisteredCorporatePrefecture?: InputMaybe<Scalars['String']['input']>;
  RegisteredCorporateTownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  RepresentAndDealerAreSame?: InputMaybe<Scalars['Boolean']['input']>;
  RepresentBirthDay?: InputMaybe<Scalars['String']['input']>;
  RepresentBuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  RepresentCityCountry?: InputMaybe<Scalars['String']['input']>;
  RepresentFirstName?: InputMaybe<Scalars['String']['input']>;
  RepresentFirstNameKana?: InputMaybe<Scalars['String']['input']>;
  RepresentLastName?: InputMaybe<Scalars['String']['input']>;
  RepresentLastNameKana?: InputMaybe<Scalars['String']['input']>;
  RepresentMailAddress?: InputMaybe<Scalars['String']['input']>;
  RepresentMobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  RepresentPosition?: InputMaybe<Scalars['String']['input']>;
  RepresentPostCode?: InputMaybe<Scalars['String']['input']>;
  RepresentPrefecture?: InputMaybe<Scalars['String']['input']>;
  RepresentTownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler1BirthDay?: InputMaybe<Scalars['String']['input']>;
  Ruler1BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  Ruler1CityCountry?: InputMaybe<Scalars['String']['input']>;
  Ruler1ImportantPublicWorker?: InputMaybe<Scalars['Boolean']['input']>;
  Ruler1ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  Ruler1MailAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler1Name?: InputMaybe<Scalars['String']['input']>;
  Ruler1PostCode?: InputMaybe<Scalars['String']['input']>;
  Ruler1Prefecture?: InputMaybe<Scalars['String']['input']>;
  Ruler1Relationship?: InputMaybe<Scalars['Int']['input']>;
  Ruler1TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler2BirthDay?: InputMaybe<Scalars['String']['input']>;
  Ruler2BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  Ruler2CityCountry?: InputMaybe<Scalars['String']['input']>;
  Ruler2ImportantPublicWorker?: InputMaybe<Scalars['Boolean']['input']>;
  Ruler2ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  Ruler2MailAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler2Name?: InputMaybe<Scalars['String']['input']>;
  Ruler2PostCode?: InputMaybe<Scalars['String']['input']>;
  Ruler2Prefecture?: InputMaybe<Scalars['String']['input']>;
  Ruler2Relationship?: InputMaybe<Scalars['Int']['input']>;
  Ruler2TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler3BirthDay?: InputMaybe<Scalars['String']['input']>;
  Ruler3BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  Ruler3CityCountry?: InputMaybe<Scalars['String']['input']>;
  Ruler3ImportantPublicWorker?: InputMaybe<Scalars['Boolean']['input']>;
  Ruler3ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  Ruler3MailAddress?: InputMaybe<Scalars['String']['input']>;
  Ruler3Name?: InputMaybe<Scalars['String']['input']>;
  Ruler3PostCode?: InputMaybe<Scalars['String']['input']>;
  Ruler3Prefecture?: InputMaybe<Scalars['String']['input']>;
  Ruler3Relationship?: InputMaybe<Scalars['Int']['input']>;
  Ruler3TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  TwoFactorAuthenticationType?: InputMaybe<Scalars['Int']['input']>;
  UniqueID?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateAdvanceQuestionParam = {
  CanTakePicture: Scalars['Boolean']['input'];
  DealerMailAddress: Scalars['String']['input'];
  HaveEKYCDocument: Scalars['Boolean']['input'];
  RepresentAndDealerAreSame?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CorporateDomesticRealEstateParam = {
  Question1: Scalars['Boolean']['input'];
  Question2?: InputMaybe<Scalars['Boolean']['input']>;
  Question3?: InputMaybe<Scalars['Boolean']['input']>;
  Question4?: InputMaybe<Scalars['Boolean']['input']>;
  Question5?: InputMaybe<Scalars['Boolean']['input']>;
  Question6?: InputMaybe<Scalars['Boolean']['input']>;
  Question7?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Success: Scalars['Boolean']['input'];
};

export type CorporateDomesticRealEstateWebAnswerInfo = {
  __typename?: 'CorporateDomesticRealEstateWebAnswerInfo';
  Question1?: Maybe<Scalars['Boolean']['output']>;
  Question1Str?: Maybe<Scalars['String']['output']>;
  Question2?: Maybe<Scalars['Boolean']['output']>;
  Question2Str?: Maybe<Scalars['String']['output']>;
  Question3?: Maybe<Scalars['Boolean']['output']>;
  Question3Str?: Maybe<Scalars['String']['output']>;
  Question4?: Maybe<Scalars['Boolean']['output']>;
  Question4Str?: Maybe<Scalars['String']['output']>;
  Question5?: Maybe<Scalars['Boolean']['output']>;
  Question5Str?: Maybe<Scalars['String']['output']>;
  Question6?: Maybe<Scalars['Boolean']['output']>;
  Question6Str?: Maybe<Scalars['String']['output']>;
  Question7?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type DateTimeInfo = {
  __typename?: 'DateTimeInfo';
  Current?: Maybe<Scalars['String']['output']>;
};

export type DeleteSubUserParam = {
  Branch: Scalars['String']['input'];
};

export type DomesticRealEstateAnswerInfo = {
  __typename?: 'DomesticRealEstateAnswerInfo';
  CorporateWebAnswer?: Maybe<CorporateDomesticRealEstateWebAnswerInfo>;
  InPersonAnswer?: Maybe<DomesticRealEstateInPersonAnswerInfo>;
  PersonalWebAnswer?: Maybe<PersonalDomesticRealEstateWebAnswerInfo>;
};

export type DomesticRealEstateInPersonAnswerInfo = {
  __typename?: 'DomesticRealEstateInPersonAnswerInfo';
  Question1?: Maybe<Scalars['Boolean']['output']>;
  Question1Str?: Maybe<Scalars['String']['output']>;
  Question2?: Maybe<Scalars['Boolean']['output']>;
  Question2Str?: Maybe<Scalars['String']['output']>;
  Question3?: Maybe<Scalars['Boolean']['output']>;
  Question3Str?: Maybe<Scalars['String']['output']>;
  Question4?: Maybe<Scalars['Boolean']['output']>;
  Question4Str?: Maybe<Scalars['String']['output']>;
  Question5?: Maybe<Scalars['Boolean']['output']>;
  Question5Str?: Maybe<Scalars['String']['output']>;
  Question6?: Maybe<Scalars['Boolean']['output']>;
  Question6Str?: Maybe<Scalars['String']['output']>;
  Question7?: Maybe<Scalars['Boolean']['output']>;
  Question7Str?: Maybe<Scalars['String']['output']>;
  Question8OtherText?: Maybe<Scalars['String']['output']>;
  Question8Str?: Maybe<Scalars['String']['output']>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type DomesticRealEstatePositionInfo = {
  __typename?: 'DomesticRealEstatePositionInfo';
  BoxFolderAttachedID?: Maybe<Scalars['String']['output']>;
  CurrentQuantity: Scalars['Int']['output'];
  CurrentRealEstatePrice: Scalars['Float']['output'];
  DividendYield: Scalars['Float']['output'];
  FirstTransferQuantity: Scalars['Int']['output'];
  FirstTransferRealEstatePrice: Scalars['Float']['output'];
  HasIssuanceDoc: Scalars['Boolean']['output'];
  HoldingPeriod: Scalars['String']['output'];
  InheritanceTaxAssessment: Scalars['Float']['output'];
  InheritanceTaxAssessmentSmallResidence: Scalars['Float']['output'];
  Linkable: Scalars['Boolean']['output'];
  ProductType: Scalars['Int']['output'];
  RealEstateName: Scalars['String']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  TransferDate?: Maybe<Scalars['String']['output']>;
  TrustEndDate?: Maybe<Scalars['String']['output']>;
};

export type DomesticRealEstatePositionList = {
  __typename?: 'DomesticRealEstatePositionList';
  Data?: Maybe<Array<Maybe<DomesticRealEstatePositionInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type DomesticRealEstateSymbolDetailInfo = {
  __typename?: 'DomesticRealEstateSymbolDetailInfo';
  AmountOptions: Array<Scalars['String']['output']>;
  ApplicationLimitDate?: Maybe<Scalars['String']['output']>;
  BuiltYear?: Maybe<Scalars['String']['output']>;
  CompressionRate?: Maybe<Scalars['String']['output']>;
  ConsumptionTaxAmount?: Maybe<Scalars['Int']['output']>;
  ContractURLLimitDate?: Maybe<Scalars['String']['output']>;
  DetailURL?: Maybe<Scalars['String']['output']>;
  DividendPeriod?: Maybe<Scalars['String']['output']>;
  DividendYield?: Maybe<Scalars['String']['output']>;
  GrossYield?: Maybe<Scalars['String']['output']>;
  ITExplanationLimitDate?: Maybe<Scalars['String']['output']>;
  ITExplanationMaxDate?: Maybe<Scalars['String']['output']>;
  ITExplanationMinDate?: Maybe<Scalars['String']['output']>;
  ImageURL?: Maybe<Scalars['String']['output']>;
  InheritanceTaxAssessmentURL?: Maybe<Scalars['String']['output']>;
  Location?: Maybe<Scalars['String']['output']>;
  LocationMapURL?: Maybe<Scalars['String']['output']>;
  MaxInvestmentQuantity?: Maybe<Scalars['Int']['output']>;
  OriginalContractBuildingName?: Maybe<Scalars['String']['output']>;
  ProductName?: Maybe<Scalars['String']['output']>;
  RealEstateBeneficiaryRightPrice?: Maybe<Scalars['Int']['output']>;
  RealEstatePriceEquivalent?: Maybe<Scalars['Int']['output']>;
  RemainingQuantity?: Maybe<Scalars['Int']['output']>;
  RepairReserveFundEquivalent?: Maybe<Scalars['Int']['output']>;
  RequiredWorkingCapitalReserveEquivalent?: Maybe<Scalars['Int']['output']>;
  SalesPlotAnnotationText?: Maybe<Scalars['String']['output']>;
  SalesQuantity?: Maybe<Scalars['String']['output']>;
  SalesUnit?: Maybe<Scalars['String']['output']>;
  SalesUnitCtrl?: Maybe<Scalars['Int']['output']>;
  SimplePreContractDocumentURL?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<Scalars['Int']['output']>;
  Symbol: Scalars['String']['output'];
  TotalSalesQuantity?: Maybe<Scalars['Int']['output']>;
  Tradable?: Maybe<Scalars['Boolean']['output']>;
  TransferDate?: Maybe<Scalars['String']['output']>;
  WebOrderLimitQuantity?: Maybe<Scalars['Int']['output']>;
};

export type DomesticRealEstateSymbolList = {
  __typename?: 'DomesticRealEstateSymbolList';
  Data: Array<DomesticRealEstateSymbolDetailInfo>;
  TotalCount: Scalars['Int']['output'];
};

export type ExecuteResult = {
  __typename?: 'ExecuteResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
};

export type FaqContentsList = {
  __typename?: 'FaqContentsList';
  Data?: Maybe<Array<Maybe<QaValuesInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type FaqInfo = {
  __typename?: 'FaqInfo';
  ID: Scalars['Int']['output'];
  QaList?: Maybe<Array<Maybe<QaValuesInfo>>>;
  Title: Scalars['String']['output'];
};

export type FaqList = {
  __typename?: 'FaqList';
  Data?: Maybe<Array<Maybe<FaqInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type IssuanceDocument = {
  __typename?: 'IssuanceDocument';
  Data: Scalars['String']['output'];
};

export type IssuanceDocumentFileInfo = {
  __typename?: 'IssuanceDocumentFileInfo';
  DisplayName: Scalars['String']['output'];
  FileName: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  IssueDate: Scalars['String']['output'];
};

export type IssuanceDocumentFileList = {
  __typename?: 'IssuanceDocumentFileList';
  Data?: Maybe<Array<Maybe<IssuanceDocumentFileInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type IssuanceDocumentFolderInfo = {
  __typename?: 'IssuanceDocumentFolderInfo';
  HasChildFolder?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export type IssuanceDocumentFolderList = {
  __typename?: 'IssuanceDocumentFolderList';
  Data?: Maybe<Array<Maybe<IssuanceDocumentFolderInfo>>>;
  Own?: Maybe<IssuanceDocumentFolderInfo>;
  TotalCount: Scalars['Int']['output'];
};

export type LeaseFundAnswerInfo = {
  __typename?: 'LeaseFundAnswerInfo';
  InPersonAnswer?: Maybe<LeaseFundInPersonAnswerInfo>;
  WebAnswer?: Maybe<LeaseFundWebAnswerInfo>;
};

export type LeaseFundInPersonAnswerInfo = {
  __typename?: 'LeaseFundInPersonAnswerInfo';
  Question1?: Maybe<Scalars['Boolean']['output']>;
  Question1Str?: Maybe<Scalars['String']['output']>;
  Question2?: Maybe<Scalars['Boolean']['output']>;
  Question2Str?: Maybe<Scalars['String']['output']>;
  Question3?: Maybe<Scalars['Boolean']['output']>;
  Question3Str?: Maybe<Scalars['String']['output']>;
  Question4?: Maybe<Scalars['Boolean']['output']>;
  Question4Str?: Maybe<Scalars['String']['output']>;
  Question5?: Maybe<Scalars['Boolean']['output']>;
  Question5Str?: Maybe<Scalars['String']['output']>;
  Question6?: Maybe<Scalars['Boolean']['output']>;
  Question6Str?: Maybe<Scalars['String']['output']>;
  Question7?: Maybe<Scalars['Boolean']['output']>;
  Question7Str?: Maybe<Scalars['String']['output']>;
  Question8?: Maybe<Scalars['Boolean']['output']>;
  Question8Str?: Maybe<Scalars['String']['output']>;
  Question9OtherText?: Maybe<Scalars['String']['output']>;
  Question9Str?: Maybe<Scalars['String']['output']>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type LeaseFundParam = {
  Question1: Scalars['Boolean']['input'];
  Question2?: InputMaybe<Scalars['Boolean']['input']>;
  Question3?: InputMaybe<Scalars['Boolean']['input']>;
  Question4?: InputMaybe<Scalars['Boolean']['input']>;
  Question5?: InputMaybe<Scalars['Boolean']['input']>;
  Question6?: InputMaybe<Scalars['Boolean']['input']>;
  Question7?: InputMaybe<Scalars['Boolean']['input']>;
  Question8?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Question8OtherText?: InputMaybe<Scalars['String']['input']>;
  Success: Scalars['Boolean']['input'];
};

export type LeaseFundWebAnswerInfo = {
  __typename?: 'LeaseFundWebAnswerInfo';
  Question1?: Maybe<Scalars['Boolean']['output']>;
  Question1Str?: Maybe<Scalars['String']['output']>;
  Question2?: Maybe<Scalars['Boolean']['output']>;
  Question2Str?: Maybe<Scalars['String']['output']>;
  Question3?: Maybe<Scalars['Boolean']['output']>;
  Question3Str?: Maybe<Scalars['String']['output']>;
  Question4?: Maybe<Scalars['Boolean']['output']>;
  Question4Str?: Maybe<Scalars['String']['output']>;
  Question5?: Maybe<Scalars['Boolean']['output']>;
  Question5Str?: Maybe<Scalars['String']['output']>;
  Question6?: Maybe<Scalars['Boolean']['output']>;
  Question6Str?: Maybe<Scalars['String']['output']>;
  Question7?: Maybe<Scalars['Boolean']['output']>;
  Question7Str?: Maybe<Scalars['String']['output']>;
  Question8?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  Question8OtherText?: Maybe<Scalars['String']['output']>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type LoginParam = {
  Account: Scalars['String']['input'];
  Password: Scalars['String']['input'];
};

export type LoginResult = {
  __typename?: 'LoginResult';
  Code: Scalars['Int']['output'];
  DisplayText?: Maybe<Scalars['String']['output']>;
  Message?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  AddSubUser?: Maybe<ExecuteResult>;
  AdvanceQuestion?: Maybe<ExecuteResult>;
  AgreeDisclosureStatement?: Maybe<ExecuteResult>;
  AgreeDocument?: Maybe<ExecuteResult>;
  AnswerCompatibility?: Maybe<ExecuteResult>;
  AnswerRecorder?: Maybe<ExecuteResult>;
  ApplySymbol?: Maybe<ApplySymbolResult>;
  ChangeAccountInfo?: Maybe<ExecuteResult>;
  ChangeDomesticRealEstateApplication?: Maybe<ExecuteResult>;
  ChangePassword?: Maybe<ExecuteResult>;
  DeleteSubUser?: Maybe<ExecuteResult>;
  Login?: Maybe<LoginResult>;
  Logout?: Maybe<ExecuteResult>;
  OpenAccount?: Maybe<ExecuteResult>;
  ReadNotification?: Maybe<ExecuteResult>;
  ReissuePassword?: Maybe<ReissuePasswordResult>;
  SMSCertificate?: Maybe<SmsCertificateResult>;
  SendContact?: Maybe<ExecuteResult>;
  SendPreContractNotify?: Maybe<ExecuteResult>;
  SendSMS?: Maybe<SendSmsResult>;
  SignContract?: Maybe<ExecuteResult>;
};


export type MutationAddSubUserArgs = {
  input?: InputMaybe<AddSubUserParam>;
};


export type MutationAdvanceQuestionArgs = {
  input?: InputMaybe<AdvanceQuestionParam>;
};


export type MutationAgreeDisclosureStatementArgs = {
  input?: InputMaybe<AgreeDisclosureStatementParam>;
};


export type MutationAgreeDocumentArgs = {
  input?: InputMaybe<AgreeDocumentParam>;
};


export type MutationAnswerCompatibilityArgs = {
  input?: InputMaybe<AnswerCompatibilityParam>;
};


export type MutationAnswerRecorderArgs = {
  input?: InputMaybe<AnswerRecorderParam>;
};


export type MutationApplySymbolArgs = {
  input?: InputMaybe<ApplySymbolParam>;
};


export type MutationChangeAccountInfoArgs = {
  input?: InputMaybe<ChangeAccountInfoParam>;
};


export type MutationChangeDomesticRealEstateApplicationArgs = {
  input?: InputMaybe<ChangeDomesticRealEstateApplicationParam>;
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordParam>;
};


export type MutationDeleteSubUserArgs = {
  input?: InputMaybe<DeleteSubUserParam>;
};


export type MutationLoginArgs = {
  input?: InputMaybe<LoginParam>;
};


export type MutationOpenAccountArgs = {
  input?: InputMaybe<OpenAccountParam>;
};


export type MutationReadNotificationArgs = {
  input?: InputMaybe<ReadNotificationParam>;
};


export type MutationReissuePasswordArgs = {
  input?: InputMaybe<ReissuePasswordParam>;
};


export type MutationSmsCertificateArgs = {
  input?: InputMaybe<SmsCertificateParam>;
};


export type MutationSendContactArgs = {
  input?: InputMaybe<SendContactParam>;
};


export type MutationSendPreContractNotifyArgs = {
  input?: InputMaybe<SendPreContractNotifyParam>;
};


export type MutationSendSmsArgs = {
  input?: InputMaybe<SendSmsParam>;
};


export type MutationSignContractArgs = {
  input?: InputMaybe<SignContractParam>;
};

export type NotificationDetailInfo = {
  __typename?: 'NotificationDetailInfo';
  ConfirmDateTime?: Maybe<Scalars['String']['output']>;
  Confirmed?: Maybe<Scalars['Boolean']['output']>;
  Contents: Scalars['String']['output'];
  DeliveryTarget: Scalars['Int']['output'];
  DeliveryType: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  PublishStartDate: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type NotificationInfo = {
  __typename?: 'NotificationInfo';
  Confirmed?: Maybe<Scalars['Boolean']['output']>;
  DeliveryTarget: Scalars['Int']['output'];
  DeliveryType: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  PublishStartDate: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type NotificationList = {
  __typename?: 'NotificationList';
  Data?: Maybe<Array<Maybe<NotificationInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type OpenAccountParam = {
  CorporateAccount?: InputMaybe<CorporateAccountParam>;
  PersonalAccount?: InputMaybe<PersonalAccountParam>;
};

export type OverseasRealEstateAnswerInfo = {
  __typename?: 'OverseasRealEstateAnswerInfo';
  InPersonAnswer?: Maybe<OverseasRealEstateInPersonAnswerInfo>;
  WebAnswer?: Maybe<OverseasRealEstateWebAnswerInfo>;
};

export type OverseasRealEstateInPersonAnswerInfo = {
  __typename?: 'OverseasRealEstateInPersonAnswerInfo';
  Question1?: Maybe<Scalars['Boolean']['output']>;
  Question1Str?: Maybe<Scalars['String']['output']>;
  Question2?: Maybe<Scalars['Boolean']['output']>;
  Question2Str?: Maybe<Scalars['String']['output']>;
  Question3?: Maybe<Scalars['Boolean']['output']>;
  Question3Str?: Maybe<Scalars['String']['output']>;
  Question4?: Maybe<Scalars['Boolean']['output']>;
  Question4Str?: Maybe<Scalars['String']['output']>;
  Question5?: Maybe<Scalars['Boolean']['output']>;
  Question5Str?: Maybe<Scalars['String']['output']>;
  Question6?: Maybe<Scalars['Boolean']['output']>;
  Question6Str?: Maybe<Scalars['String']['output']>;
  Question7?: Maybe<Scalars['Boolean']['output']>;
  Question7Str?: Maybe<Scalars['String']['output']>;
  Question8?: Maybe<Scalars['Boolean']['output']>;
  Question8Str?: Maybe<Scalars['String']['output']>;
  Question9?: Maybe<Scalars['Boolean']['output']>;
  Question9Str?: Maybe<Scalars['String']['output']>;
  Question10OtherText?: Maybe<Scalars['String']['output']>;
  Question10Str?: Maybe<Scalars['String']['output']>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type OverseasRealEstateParam = {
  Question1: Scalars['Boolean']['input'];
  Question2?: InputMaybe<Scalars['Boolean']['input']>;
  Question3?: InputMaybe<Scalars['Boolean']['input']>;
  Question4?: InputMaybe<Scalars['Boolean']['input']>;
  Question5?: InputMaybe<Scalars['Boolean']['input']>;
  Question6?: InputMaybe<Scalars['Boolean']['input']>;
  Question7?: InputMaybe<Scalars['Boolean']['input']>;
  Question8?: InputMaybe<Scalars['Boolean']['input']>;
  Question9?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Success: Scalars['Boolean']['input'];
};

export type OverseasRealEstatePositionInfo = {
  __typename?: 'OverseasRealEstatePositionInfo';
  ContractDate?: Maybe<Scalars['String']['output']>;
  HasIssuanceDoc: Scalars['Boolean']['output'];
  InitialExchangeRate: Scalars['Float']['output'];
  InvestmentAmountYen: Scalars['Float']['output'];
  Linkable: Scalars['Boolean']['output'];
  OperatingEndDate?: Maybe<Scalars['String']['output']>;
  PaLDistMonth: Array<Scalars['String']['output']>;
  ProductType: Scalars['Int']['output'];
  ProjectedHoldingPeriod?: Maybe<Scalars['String']['output']>;
  RealEstateName: Scalars['String']['output'];
  Status: Scalars['String']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
};

export type OverseasRealEstatePositionList = {
  __typename?: 'OverseasRealEstatePositionList';
  Data?: Maybe<Array<Maybe<OverseasRealEstatePositionInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type OverseasRealEstateSymbolDetailInfo = {
  __typename?: 'OverseasRealEstateSymbolDetailInfo';
  AccruedInterest?: Maybe<Scalars['String']['output']>;
  AmountOptions: Array<Scalars['String']['output']>;
  ApplicationLimitDate?: Maybe<Scalars['String']['output']>;
  BoundaryAmount?: Maybe<Scalars['Float']['output']>;
  BuildingName?: Maybe<Scalars['String']['output']>;
  BuildingType?: Maybe<Scalars['String']['output']>;
  BusinessStartDate: Scalars['String']['output'];
  CompletionYear?: Maybe<Scalars['String']['output']>;
  DisplayDate1FromBySettlement?: Maybe<Scalars['String']['output']>;
  DisplayDate1ToBySettlement?: Maybe<Scalars['String']['output']>;
  DisplayDate2FromBySettlement?: Maybe<Scalars['String']['output']>;
  DisplayDate2ToBySettlement?: Maybe<Scalars['String']['output']>;
  DurationOfPartnership?: Maybe<Scalars['String']['output']>;
  FinalBusinessProfitRate: Scalars['String']['output'];
  HoldingPeriod?: Maybe<Scalars['String']['output']>;
  ImageUrl: Scalars['String']['output'];
  InitialYearExpenseRate: Scalars['String']['output'];
  Location?: Maybe<Scalars['String']['output']>;
  LowerRate?: Maybe<Scalars['Float']['output']>;
  MaxInvestmentAmount?: Maybe<Scalars['Float']['output']>;
  MinimumInvestmentAmount: Scalars['Int']['output'];
  PaLDistMonth: Array<Scalars['String']['output']>;
  PreContractDocumentURL: Scalars['String']['output'];
  ProductType: Scalars['Int']['output'];
  SalesUnitCtrl?: Maybe<Scalars['Int']['output']>;
  SimplePreContractDocumentURL: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  SymbolShortName: Scalars['String']['output'];
  TotalDocumentURL: Scalars['String']['output'];
  Tradable?: Maybe<Scalars['Boolean']['output']>;
  TransferEndDate?: Maybe<Scalars['String']['output']>;
  TransferInterest?: Maybe<Scalars['Float']['output']>;
  TransferInterestPattern: Scalars['Int']['output'];
  TransferStartDate?: Maybe<Scalars['String']['output']>;
  UpperRate?: Maybe<Scalars['Float']['output']>;
};

export type OverseasRealEstateSymbolList = {
  __typename?: 'OverseasRealEstateSymbolList';
  Data: Array<OverseasRealEstateSymbolDetailInfo>;
  TotalCount: Scalars['Int']['output'];
};

export type OverseasRealEstateWebAnswerInfo = {
  __typename?: 'OverseasRealEstateWebAnswerInfo';
  Question1?: Maybe<Scalars['Boolean']['output']>;
  Question1Str?: Maybe<Scalars['String']['output']>;
  Question2?: Maybe<Scalars['Boolean']['output']>;
  Question2Str?: Maybe<Scalars['String']['output']>;
  Question3?: Maybe<Scalars['Boolean']['output']>;
  Question3Str?: Maybe<Scalars['String']['output']>;
  Question4?: Maybe<Scalars['Boolean']['output']>;
  Question4Str?: Maybe<Scalars['String']['output']>;
  Question5?: Maybe<Scalars['Boolean']['output']>;
  Question5Str?: Maybe<Scalars['String']['output']>;
  Question6?: Maybe<Scalars['Boolean']['output']>;
  Question6Str?: Maybe<Scalars['String']['output']>;
  Question7?: Maybe<Scalars['Boolean']['output']>;
  Question7Str?: Maybe<Scalars['String']['output']>;
  Question8?: Maybe<Scalars['Boolean']['output']>;
  Question8Str?: Maybe<Scalars['String']['output']>;
  Question9?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type PdfInfo = {
  __typename?: 'PdfInfo';
  ConsentDate: Scalars['String']['output'];
  PdfData: Scalars['String']['output'];
};

export type PersonalAccountParam = {
  Birthdate?: InputMaybe<Scalars['String']['input']>;
  BuildingNameAndRoomNumber?: InputMaybe<Scalars['String']['input']>;
  CanTakePicture?: InputMaybe<Scalars['Boolean']['input']>;
  CityCountry?: InputMaybe<Scalars['String']['input']>;
  ConfirmResponsibility?: InputMaybe<Scalars['Boolean']['input']>;
  ContactFaxNumber?: InputMaybe<Scalars['String']['input']>;
  ContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  CountryOfResidence?: InputMaybe<Scalars['Int']['input']>;
  DealerFirstName?: InputMaybe<Scalars['String']['input']>;
  DealerFirstNameKana?: InputMaybe<Scalars['String']['input']>;
  DealerLastName?: InputMaybe<Scalars['String']['input']>;
  DealerLastNameKana?: InputMaybe<Scalars['String']['input']>;
  DealerMailAddress?: InputMaybe<Scalars['String']['input']>;
  DealerMobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  DomesticRealEstatePurpose?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  DomesticRealEstatePurposeOtherText?: InputMaybe<Scalars['String']['input']>;
  ElectronicDocumentAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  ElectronicDocumentAgreementDateTime?: InputMaybe<Scalars['String']['input']>;
  Fatca?: InputMaybe<Scalars['Int']['input']>;
  HasNoInvoiceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  HaveEKYCDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ImportantPublicWorker?: InputMaybe<Scalars['Int']['input']>;
  ImportantPublicWorkerOtherText?: InputMaybe<Scalars['String']['input']>;
  InvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  Nationality?: InputMaybe<Scalars['Int']['input']>;
  Occupation?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  OccupationOtherText?: InputMaybe<Scalars['String']['input']>;
  PersonalMainBusinessContent?: InputMaybe<Scalars['Int']['input']>;
  PersonalMainBusinessContentOtherText?: InputMaybe<Scalars['String']['input']>;
  PersonalOtherBusinessContent?: InputMaybe<Scalars['Int']['input']>;
  PersonalOtherBusinessContentOtherText?: InputMaybe<Scalars['String']['input']>;
  PostCode?: InputMaybe<Scalars['String']['input']>;
  Prefecture?: InputMaybe<Scalars['String']['input']>;
  Sex?: InputMaybe<Scalars['Int']['input']>;
  TownStreetAddress?: InputMaybe<Scalars['String']['input']>;
  TransferAccountHolderName?: InputMaybe<Scalars['String']['input']>;
  TransferAccountNumber?: InputMaybe<Scalars['String']['input']>;
  TransferAccountType?: InputMaybe<Scalars['Int']['input']>;
  TransferBankName?: InputMaybe<Scalars['String']['input']>;
  TransferBranchName?: InputMaybe<Scalars['String']['input']>;
  TwoFactorAuthenticationType?: InputMaybe<Scalars['Int']['input']>;
  UniqueID?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalAdvanceQuestionParam = {
  AdvanceCountryOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
  AdvanceNationality?: InputMaybe<Scalars['Boolean']['input']>;
  Birthdate?: InputMaybe<Scalars['String']['input']>;
  CanTakePicture: Scalars['Boolean']['input'];
  DealerMailAddress: Scalars['String']['input'];
  HaveEKYCDocument: Scalars['Boolean']['input'];
};

export type PersonalDomesticRealEstateParam = {
  Question1: Scalars['Boolean']['input'];
  Question2?: InputMaybe<Scalars['Boolean']['input']>;
  Question3?: InputMaybe<Scalars['Boolean']['input']>;
  Question4?: InputMaybe<Scalars['Boolean']['input']>;
  Question5?: InputMaybe<Scalars['Boolean']['input']>;
  Question6?: InputMaybe<Scalars['Int']['input']>;
  Question7?: InputMaybe<Scalars['Int']['input']>;
  Question8?: InputMaybe<Scalars['Boolean']['input']>;
  Question9?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Success: Scalars['Boolean']['input'];
};

export type PersonalDomesticRealEstateWebAnswerInfo = {
  __typename?: 'PersonalDomesticRealEstateWebAnswerInfo';
  Question1?: Maybe<Scalars['Boolean']['output']>;
  Question1Str?: Maybe<Scalars['String']['output']>;
  Question2?: Maybe<Scalars['Boolean']['output']>;
  Question2Str?: Maybe<Scalars['String']['output']>;
  Question3?: Maybe<Scalars['Boolean']['output']>;
  Question3Str?: Maybe<Scalars['String']['output']>;
  Question4?: Maybe<Scalars['Boolean']['output']>;
  Question4Str?: Maybe<Scalars['String']['output']>;
  Question5?: Maybe<Scalars['Boolean']['output']>;
  Question5Str?: Maybe<Scalars['String']['output']>;
  Question6?: Maybe<Scalars['Int']['output']>;
  Question6Str?: Maybe<Scalars['String']['output']>;
  Question7?: Maybe<Scalars['Int']['output']>;
  Question7Str?: Maybe<Scalars['String']['output']>;
  Question8?: Maybe<Scalars['Boolean']['output']>;
  Question8Str?: Maybe<Scalars['String']['output']>;
  Question9?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  Question9Str?: Maybe<Scalars['String']['output']>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type PositionInfo = {
  __typename?: 'PositionInfo';
  ContractDate?: Maybe<Scalars['String']['output']>;
  HasIssuanceDoc: Scalars['Boolean']['output'];
  InitialExchangeRate: Scalars['Float']['output'];
  InvestmentAmountDollar: Scalars['Float']['output'];
  InvestmentAmountYen: Scalars['Float']['output'];
  LeaseEndDate?: Maybe<Scalars['String']['output']>;
  Linkable: Scalars['Boolean']['output'];
  PaLDistMonth: Array<Scalars['String']['output']>;
  ProductType: Scalars['Int']['output'];
  PurchaseOptionDate: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  SymbolShortName: Scalars['String']['output'];
  TenantName: Scalars['String']['output'];
};

export type PositionList = {
  __typename?: 'PositionList';
  Data?: Maybe<Array<Maybe<PositionInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type QaValuesInfo = {
  __typename?: 'QaValuesInfo';
  Answer: Scalars['String']['output'];
  QAID: Scalars['Int']['output'];
  Question: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  GetAccountDetailInfo?: Maybe<AccountDetailInfo>;
  GetAccountInfo?: Maybe<AccountInfo>;
  GetAddressInfo?: Maybe<AddressInfo>;
  GetAdvanceQuestion?: Maybe<AdvanceQuestionValue>;
  GetAgreementDocument?: Maybe<AgreementDocumentList>;
  GetAgreementDocumentList?: Maybe<AgreementDocumentList>;
  GetApplication?: Maybe<ApplicationInfo>;
  GetApplicationList?: Maybe<ApplicationList>;
  GetBrokerBranchInfo?: Maybe<BrokerList>;
  GetBrokerInfo?: Maybe<BrokerList>;
  GetCompatibility?: Maybe<Compatibility>;
  GetContractInfo?: Maybe<ContractInfo>;
  GetDateTime?: Maybe<DateTimeInfo>;
  GetDomesticRealEstatePositionList?: Maybe<DomesticRealEstatePositionList>;
  GetDomesticRealEstateSymbolInfo?: Maybe<DomesticRealEstateSymbolDetailInfo>;
  GetDomesticRealEstateSymbolList?: Maybe<DomesticRealEstateSymbolList>;
  GetFaqContentsList?: Maybe<FaqContentsList>;
  GetFaqList?: Maybe<FaqList>;
  GetIssuanceDocument?: Maybe<IssuanceDocument>;
  GetIssuanceDocumentFileList?: Maybe<IssuanceDocumentFileList>;
  GetIssuanceDocumentFolderList?: Maybe<IssuanceDocumentFolderList>;
  GetNotificationInfo?: Maybe<NotificationDetailInfo>;
  GetNotificationList?: Maybe<NotificationList>;
  GetOverseasRealEstatePositionList?: Maybe<OverseasRealEstatePositionList>;
  GetOverseasRealEstateSymbolInfo?: Maybe<OverseasRealEstateSymbolDetailInfo>;
  GetOverseasRealEstateSymbolList?: Maybe<OverseasRealEstateSymbolList>;
  GetPdfInfo?: Maybe<PdfInfo>;
  GetPositionList?: Maybe<PositionList>;
  GetSubUserList?: Maybe<SubUserList>;
  GetSymbolInfo?: Maybe<SymbolDetailInfo>;
  GetSymbolList?: Maybe<SymbolList>;
};


export type QueryGetAddressInfoArgs = {
  postCode: Scalars['String']['input'];
};


export type QueryGetAdvanceQuestionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetApplicationListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBrokerBranchInfoArgs = {
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
  brokerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBrokerInfoArgs = {
  brokerCode?: InputMaybe<Scalars['String']['input']>;
  brokerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCompatibilityArgs = {
  assetType: Scalars['Int']['input'];
  conditionType: Scalars['Int']['input'];
};


export type QueryGetContractInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetDomesticRealEstatePositionListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetDomesticRealEstateSymbolInfoArgs = {
  symbol?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDomesticRealEstateSymbolListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  productType?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetFaqContentsListArgs = {
  categoryId: Scalars['Int']['input'];
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolProductType: Scalars['Int']['input'];
};


export type QueryGetFaqListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolProductType: Scalars['Int']['input'];
};


export type QueryGetIssuanceDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIssuanceDocumentFileListArgs = {
  count: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetIssuanceDocumentFolderListArgs = {
  count: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetNotificationInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetNotificationListArgs = {
  count: Scalars['Int']['input'];
  deliveryTarget?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetOverseasRealEstatePositionListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetOverseasRealEstateSymbolInfoArgs = {
  symbol?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOverseasRealEstateSymbolListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  productType?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPdfInfoArgs = {
  companyName: Scalars['String']['input'];
  pdfName: Scalars['String']['input'];
};


export type QueryGetPositionListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetSymbolInfoArgs = {
  symbol?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSymbolListArgs = {
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  productType?: InputMaybe<Scalars['Int']['input']>;
};

export type ReadNotificationParam = {
  ID?: InputMaybe<Scalars['String']['input']>;
};

export type ReissuePasswordParam = {
  Account: Scalars['String']['input'];
  PhoneNumber: Scalars['String']['input'];
};

export type ReissuePasswordResult = {
  __typename?: 'ReissuePasswordResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type SmsCertificateParam = {
  AuthenticationCode: Scalars['String']['input'];
  ProvisionalToken: Scalars['String']['input'];
  Type: Scalars['Int']['input'];
};

export type SmsCertificateResult = {
  __typename?: 'SMSCertificateResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  Token?: Maybe<Scalars['String']['output']>;
};

export type SendContactParam = {
  Details: Scalars['String']['input'];
};

export type SendPreContractNotifyParam = {
  Symbol: Scalars['String']['input'];
};

export type SendSmsParam = {
  Account?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  PhoneNumber?: InputMaybe<Scalars['String']['input']>;
  ProvisionalToken?: InputMaybe<Scalars['String']['input']>;
  Type: Scalars['Int']['input'];
};

export type SendSmsResult = {
  __typename?: 'SendSMSResult';
  Code: Scalars['Int']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  ProvisionalToken?: Maybe<Scalars['String']['output']>;
};

export type SignContractParam = {
  CheckedAssignmentAgreementDocument?: InputMaybe<Scalars['Boolean']['input']>;
  CheckedContractAgreementDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ID?: InputMaybe<Scalars['String']['input']>;
};

export type SubUserInfo = {
  __typename?: 'SubUserInfo';
  Branch: Scalars['String']['output'];
  MailAddress: Scalars['String']['output'];
  PhoneNumber: Scalars['String']['output'];
};

export type SubUserList = {
  __typename?: 'SubUserList';
  Data?: Maybe<Array<Maybe<SubUserInfo>>>;
  TotalCount: Scalars['Int']['output'];
};

export type SymbolDetailInfo = {
  __typename?: 'SymbolDetailInfo';
  AccruedInterest?: Maybe<Scalars['String']['output']>;
  AmountOptions: Array<Scalars['String']['output']>;
  BoundaryAmount?: Maybe<Scalars['Float']['output']>;
  DisplayDate1FromBySettlement?: Maybe<Scalars['String']['output']>;
  DisplayDate1ToBySettlement?: Maybe<Scalars['String']['output']>;
  DisplayDate2FromBySettlement?: Maybe<Scalars['String']['output']>;
  DisplayDate2ToBySettlement?: Maybe<Scalars['String']['output']>;
  FirstYearDeductionRate: Array<Scalars['String']['output']>;
  ImageUrl: Scalars['String']['output'];
  LeaseStartDate: Scalars['String']['output'];
  LowerRate?: Maybe<Scalars['Float']['output']>;
  MaxInvestmentAmount?: Maybe<Scalars['Float']['output']>;
  MinimumInvestmentAmount: Scalars['Int']['output'];
  PaLDistMonth: Array<Scalars['String']['output']>;
  PreContractDocumentURL: Scalars['String']['output'];
  ProductType: Scalars['Int']['output'];
  PurchaseOptions: Array<SymbolPurchaseOption>;
  SalesUnitCtrl?: Maybe<Scalars['Int']['output']>;
  SimplePreContractDocumentURL: Scalars['String']['output'];
  Status: Scalars['Int']['output'];
  Symbol: Scalars['String']['output'];
  SymbolName: Scalars['String']['output'];
  SymbolShortName: Scalars['String']['output'];
  SymbolType: Scalars['String']['output'];
  TenantName: Scalars['String']['output'];
  TenantSummary?: Maybe<Scalars['String']['output']>;
  TotalInvestmentAmount: Scalars['Float']['output'];
  Tradable?: Maybe<Scalars['Boolean']['output']>;
  TransferEndDate?: Maybe<Scalars['String']['output']>;
  TransferInterest?: Maybe<Scalars['Float']['output']>;
  TransferInterestPattern: Scalars['Int']['output'];
  TransferStartDate?: Maybe<Scalars['String']['output']>;
  UpperRate?: Maybe<Scalars['Float']['output']>;
};

export type SymbolList = {
  __typename?: 'SymbolList';
  Data: Array<SymbolDetailInfo>;
  TotalCount: Scalars['Int']['output'];
};

export type SymbolPurchaseOption = {
  __typename?: 'SymbolPurchaseOption';
  Date: Scalars['String']['output'];
  Elapsed: Scalars['String']['output'];
};

export type LoginMutationVariables = Exact<{
  input?: InputMaybe<LoginParam>;
}>;


export type LoginMutation = { __typename?: 'Mutation', Login?: { __typename?: 'LoginResult', Code: number, Message?: string | null, ProvisionalToken?: string | null, DisplayText?: string | null } | null };

export type NotificationListItemFragment = { __typename?: 'NotificationInfo', ID: string, DeliveryType: number, DeliveryTarget: number, Title: string, Confirmed?: boolean | null, PublishStartDate: string };

export type HomeQueryVariables = Exact<{
  notificationCount: Scalars['Int']['input'];
}>;


export type HomeQuery = { __typename?: 'Query', AllNotificationList?: { __typename?: 'NotificationList', TotalCount: number, Data?: Array<{ __typename?: 'NotificationInfo', ID: string, DeliveryType: number, DeliveryTarget: number, Title: string, Confirmed?: boolean | null, PublishStartDate: string } | null> | null } | null, PersonalNotificationList?: { __typename?: 'NotificationList', TotalCount: number, Data?: Array<{ __typename?: 'NotificationInfo', ID: string, DeliveryType: number, DeliveryTarget: number, Title: string, Confirmed?: boolean | null, PublishStartDate: string } | null> | null } | null };

export type GetNotificationListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  deliveryTarget?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNotificationListQuery = { __typename?: 'Query', GetNotificationList?: { __typename?: 'NotificationList', TotalCount: number, Data?: Array<{ __typename?: 'NotificationInfo', ID: string, DeliveryType: number, DeliveryTarget: number, Title: string, Confirmed?: boolean | null, PublishStartDate: string } | null> | null } | null };

export type GetNotificationInfoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNotificationInfoQuery = { __typename?: 'Query', GetNotificationInfo?: { __typename?: 'NotificationDetailInfo', ID: string, DeliveryType: number, DeliveryTarget: number, Title: string, Contents: string, Confirmed?: boolean | null, PublishStartDate: string, ConfirmDateTime?: string | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  input?: InputMaybe<ReadNotificationParam>;
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', ReadNotification?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type SmsCertificateMutationVariables = Exact<{
  input?: InputMaybe<SmsCertificateParam>;
}>;


export type SmsCertificateMutation = { __typename?: 'Mutation', SMSCertificate?: { __typename?: 'SMSCertificateResult', Code: number, Message?: string | null, Token?: string | null } | null };

export type SendSmsMutationVariables = Exact<{
  input?: InputMaybe<SendSmsParam>;
}>;


export type SendSmsMutation = { __typename?: 'Mutation', SendSMS?: { __typename?: 'SendSMSResult', Code: number, Message?: string | null, ProvisionalToken?: string | null } | null };

export type ReissuePasswordMutationVariables = Exact<{
  input?: InputMaybe<ReissuePasswordParam>;
}>;


export type ReissuePasswordMutation = { __typename?: 'Mutation', ReissuePassword?: { __typename?: 'ReissuePasswordResult', Code: number, Message?: string | null, ProvisionalToken?: string | null } | null };

export type GetSymbolListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  productType: Scalars['Int']['input'];
}>;


export type GetSymbolListQuery = { __typename?: 'Query', GetSymbolList?: { __typename?: 'SymbolList', TotalCount: number, Data: Array<{ __typename?: 'SymbolDetailInfo', Symbol: string, SymbolShortName: string, SymbolName: string, SymbolType: string, ProductType: number, Status: number, ImageUrl: string, TenantName: string, PaLDistMonth: Array<string>, FirstYearDeductionRate: Array<string>, LeaseStartDate: string, MinimumInvestmentAmount: number, TotalInvestmentAmount: number, PreContractDocumentURL: string, SimplePreContractDocumentURL: string, TransferStartDate?: string | null, TransferEndDate?: string | null, TransferInterest?: number | null, TransferInterestPattern: number, DisplayDate1FromBySettlement?: string | null, DisplayDate1ToBySettlement?: string | null, DisplayDate2FromBySettlement?: string | null, DisplayDate2ToBySettlement?: string | null, TenantSummary?: string | null, AccruedInterest?: string | null, AmountOptions: Array<string>, MaxInvestmentAmount?: number | null, SalesUnitCtrl?: number | null, PurchaseOptions: Array<{ __typename?: 'SymbolPurchaseOption', Date: string, Elapsed: string }> }> } | null };

export type GetSymbolInfoQueryVariables = Exact<{
  symbol: Scalars['String']['input'];
}>;


export type GetSymbolInfoQuery = { __typename?: 'Query', GetSymbolInfo?: { __typename?: 'SymbolDetailInfo', Symbol: string, SymbolShortName: string, SymbolName: string, SymbolType: string, ProductType: number, Status: number, ImageUrl: string, TenantName: string, PaLDistMonth: Array<string>, FirstYearDeductionRate: Array<string>, LeaseStartDate: string, MinimumInvestmentAmount: number, TotalInvestmentAmount: number, PreContractDocumentURL: string, SimplePreContractDocumentURL: string, TransferStartDate?: string | null, TransferEndDate?: string | null, TransferInterest?: number | null, TransferInterestPattern: number, Tradable?: boolean | null, DisplayDate1FromBySettlement?: string | null, DisplayDate1ToBySettlement?: string | null, DisplayDate2FromBySettlement?: string | null, DisplayDate2ToBySettlement?: string | null, TenantSummary?: string | null, AccruedInterest?: string | null, AmountOptions: Array<string>, BoundaryAmount?: number | null, LowerRate?: number | null, UpperRate?: number | null, MaxInvestmentAmount?: number | null, SalesUnitCtrl?: number | null, PurchaseOptions: Array<{ __typename?: 'SymbolPurchaseOption', Date: string, Elapsed: string }> } | null };

export type GetOverseasRealEstateSymbolListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  productType: Scalars['Int']['input'];
}>;


export type GetOverseasRealEstateSymbolListQuery = { __typename?: 'Query', GetOverseasRealEstateSymbolList?: { __typename?: 'OverseasRealEstateSymbolList', TotalCount: number, Data: Array<{ __typename?: 'OverseasRealEstateSymbolDetailInfo', Symbol: string, SymbolName: string, SymbolShortName: string, Status: number, PaLDistMonth: Array<string>, MinimumInvestmentAmount: number, ImageUrl: string, PreContractDocumentURL: string, SimplePreContractDocumentURL: string, TransferStartDate?: string | null, TransferEndDate?: string | null, TransferInterest?: number | null, TransferInterestPattern: number, ApplicationLimitDate?: string | null, DisplayDate1FromBySettlement?: string | null, DisplayDate1ToBySettlement?: string | null, DisplayDate2FromBySettlement?: string | null, DisplayDate2ToBySettlement?: string | null, TotalDocumentURL: string, InitialYearExpenseRate: string, DurationOfPartnership?: string | null, ProductType: number, CompletionYear?: string | null, BuildingType?: string | null, BuildingName?: string | null, Location?: string | null, BusinessStartDate: string, FinalBusinessProfitRate: string, HoldingPeriod?: string | null, Tradable?: boolean | null, AmountOptions: Array<string>, MaxInvestmentAmount?: number | null, AccruedInterest?: string | null, SalesUnitCtrl?: number | null }> } | null };

export type GetOverseasRealEstateSymbolInfoQueryVariables = Exact<{
  symbol: Scalars['String']['input'];
}>;


export type GetOverseasRealEstateSymbolInfoQuery = { __typename?: 'Query', GetOverseasRealEstateSymbolInfo?: { __typename?: 'OverseasRealEstateSymbolDetailInfo', Symbol: string, SymbolName: string, SymbolShortName: string, Status: number, PaLDistMonth: Array<string>, MinimumInvestmentAmount: number, ImageUrl: string, PreContractDocumentURL: string, SimplePreContractDocumentURL: string, TransferStartDate?: string | null, TransferEndDate?: string | null, TransferInterest?: number | null, TransferInterestPattern: number, ApplicationLimitDate?: string | null, DisplayDate1FromBySettlement?: string | null, DisplayDate1ToBySettlement?: string | null, DisplayDate2FromBySettlement?: string | null, DisplayDate2ToBySettlement?: string | null, TotalDocumentURL: string, InitialYearExpenseRate: string, DurationOfPartnership?: string | null, ProductType: number, CompletionYear?: string | null, BuildingType?: string | null, BuildingName?: string | null, Location?: string | null, BusinessStartDate: string, FinalBusinessProfitRate: string, HoldingPeriod?: string | null, Tradable?: boolean | null, AmountOptions: Array<string>, MaxInvestmentAmount?: number | null, AccruedInterest?: string | null, SalesUnitCtrl?: number | null, BoundaryAmount?: number | null, LowerRate?: number | null, UpperRate?: number | null } | null };

export type GetDomesticRealEstateSymbolListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  productType: Scalars['Int']['input'];
}>;


export type GetDomesticRealEstateSymbolListQuery = { __typename?: 'Query', GetDomesticRealEstateSymbolList?: { __typename?: 'DomesticRealEstateSymbolList', TotalCount: number, Data: Array<{ __typename?: 'DomesticRealEstateSymbolDetailInfo', Symbol: string, WebOrderLimitQuantity?: number | null, RemainingQuantity?: number | null, Status?: number | null, DividendPeriod?: string | null, CompressionRate?: string | null, MaxInvestmentQuantity?: number | null, AmountOptions: Array<string>, BuiltYear?: string | null, GrossYield?: string | null, DividendYield?: string | null, SalesUnit?: string | null, SalesUnitCtrl?: number | null, ImageURL?: string | null, SimplePreContractDocumentURL?: string | null, DetailURL?: string | null, InheritanceTaxAssessmentURL?: string | null, LocationMapURL?: string | null, ApplicationLimitDate?: string | null, TransferDate?: string | null, ITExplanationMinDate?: string | null, ITExplanationMaxDate?: string | null, ITExplanationLimitDate?: string | null, ContractURLLimitDate?: string | null, ProductName?: string | null, OriginalContractBuildingName?: string | null, SalesQuantity?: string | null, TotalSalesQuantity?: number | null, RealEstatePriceEquivalent?: number | null, ConsumptionTaxAmount?: number | null, RepairReserveFundEquivalent?: number | null, RequiredWorkingCapitalReserveEquivalent?: number | null, RealEstateBeneficiaryRightPrice?: number | null, Location?: string | null, SalesPlotAnnotationText?: string | null, Tradable?: boolean | null }> } | null };

export type GetDomesticRealEstateSymbolInfoQueryVariables = Exact<{
  symbol: Scalars['String']['input'];
}>;


export type GetDomesticRealEstateSymbolInfoQuery = { __typename?: 'Query', GetDomesticRealEstateSymbolInfo?: { __typename?: 'DomesticRealEstateSymbolDetailInfo', Symbol: string, WebOrderLimitQuantity?: number | null, RemainingQuantity?: number | null, Status?: number | null, DividendPeriod?: string | null, CompressionRate?: string | null, MaxInvestmentQuantity?: number | null, AmountOptions: Array<string>, BuiltYear?: string | null, GrossYield?: string | null, DividendYield?: string | null, SalesUnit?: string | null, SalesUnitCtrl?: number | null, ImageURL?: string | null, SimplePreContractDocumentURL?: string | null, DetailURL?: string | null, InheritanceTaxAssessmentURL?: string | null, LocationMapURL?: string | null, ApplicationLimitDate?: string | null, TransferDate?: string | null, ITExplanationMinDate?: string | null, ITExplanationMaxDate?: string | null, ITExplanationLimitDate?: string | null, ContractURLLimitDate?: string | null, ProductName?: string | null, OriginalContractBuildingName?: string | null, SalesQuantity?: string | null, TotalSalesQuantity?: number | null, RealEstatePriceEquivalent?: number | null, ConsumptionTaxAmount?: number | null, RepairReserveFundEquivalent?: number | null, RequiredWorkingCapitalReserveEquivalent?: number | null, RealEstateBeneficiaryRightPrice?: number | null, Location?: string | null, SalesPlotAnnotationText?: string | null, Tradable?: boolean | null } | null };

export type AnswerCompatibilityMutationVariables = Exact<{
  input?: InputMaybe<AnswerCompatibilityParam>;
}>;


export type AnswerCompatibilityMutation = { __typename?: 'Mutation', AnswerCompatibility?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type AnswerRecorderMutationVariables = Exact<{
  input?: InputMaybe<AnswerRecorderParam>;
}>;


export type AnswerRecorderMutation = { __typename?: 'Mutation', AnswerRecorder?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetCompatibilityQueryVariables = Exact<{
  conditionType: Scalars['Int']['input'];
  assetType: Scalars['Int']['input'];
}>;


export type GetCompatibilityQuery = { __typename?: 'Query', GetCompatibility?: { __typename?: 'Compatibility', LeaseFundAnswer?: { __typename?: 'LeaseFundAnswerInfo', WebAnswer?: { __typename?: 'LeaseFundWebAnswerInfo', Question1?: boolean | null, Question2?: boolean | null, Question3?: boolean | null, Question4?: boolean | null, Question5?: boolean | null, Question6?: boolean | null, Question7?: boolean | null, Question8?: Array<number | null> | null, Question1Str?: string | null, Question2Str?: string | null, Question3Str?: string | null, Question4Str?: string | null, Question5Str?: string | null, Question6Str?: string | null, Question7Str?: string | null, Question8OtherText?: string | null, Success?: boolean | null } | null, InPersonAnswer?: { __typename?: 'LeaseFundInPersonAnswerInfo', Question1?: boolean | null, Question2?: boolean | null, Question3?: boolean | null, Question4?: boolean | null, Question5?: boolean | null, Question6?: boolean | null, Question7?: boolean | null, Question8?: boolean | null, Question1Str?: string | null, Question2Str?: string | null, Question3Str?: string | null, Question4Str?: string | null, Question5Str?: string | null, Question6Str?: string | null, Question7Str?: string | null, Question8Str?: string | null, Question9Str?: string | null, Question9OtherText?: string | null, Success?: boolean | null } | null } | null, DomesticRealEstateAnswer?: { __typename?: 'DomesticRealEstateAnswerInfo', CorporateWebAnswer?: { __typename?: 'CorporateDomesticRealEstateWebAnswerInfo', Question1?: boolean | null, Question2?: boolean | null, Question3?: boolean | null, Question4?: boolean | null, Question5?: boolean | null, Question6?: boolean | null, Question7?: Array<number | null> | null, Question1Str?: string | null, Question2Str?: string | null, Question3Str?: string | null, Question4Str?: string | null, Question5Str?: string | null, Question6Str?: string | null, Success?: boolean | null } | null, PersonalWebAnswer?: { __typename?: 'PersonalDomesticRealEstateWebAnswerInfo', Question1?: boolean | null, Question2?: boolean | null, Question3?: boolean | null, Question4?: boolean | null, Question5?: boolean | null, Question6?: number | null, Question7?: number | null, Question8?: boolean | null, Question9?: Array<number | null> | null, Question1Str?: string | null, Question2Str?: string | null, Question3Str?: string | null, Question4Str?: string | null, Question5Str?: string | null, Question6Str?: string | null, Question7Str?: string | null, Question8Str?: string | null, Success?: boolean | null } | null, InPersonAnswer?: { __typename?: 'DomesticRealEstateInPersonAnswerInfo', Question1?: boolean | null, Question2?: boolean | null, Question3?: boolean | null, Question4?: boolean | null, Question5?: boolean | null, Question6?: boolean | null, Question7?: boolean | null, Question1Str?: string | null, Question2Str?: string | null, Question3Str?: string | null, Question4Str?: string | null, Question5Str?: string | null, Question6Str?: string | null, Question7Str?: string | null, Question8Str?: string | null, Question8OtherText?: string | null, Success?: boolean | null } | null } | null, OverseasRealEstateAnswer?: { __typename?: 'OverseasRealEstateAnswerInfo', WebAnswer?: { __typename?: 'OverseasRealEstateWebAnswerInfo', Question1?: boolean | null, Question2?: boolean | null, Question3?: boolean | null, Question4?: boolean | null, Question5?: boolean | null, Question6?: boolean | null, Question7?: boolean | null, Question8?: boolean | null, Question9?: Array<number | null> | null, Question1Str?: string | null, Question2Str?: string | null, Question3Str?: string | null, Question4Str?: string | null, Question5Str?: string | null, Question6Str?: string | null, Question7Str?: string | null, Question8Str?: string | null, Success?: boolean | null } | null, InPersonAnswer?: { __typename?: 'OverseasRealEstateInPersonAnswerInfo', Question1?: boolean | null, Question2?: boolean | null, Question3?: boolean | null, Question4?: boolean | null, Question5?: boolean | null, Question6?: boolean | null, Question7?: boolean | null, Question8?: boolean | null, Question9?: boolean | null, Question1Str?: string | null, Question2Str?: string | null, Question3Str?: string | null, Question4Str?: string | null, Question5Str?: string | null, Question6Str?: string | null, Question7Str?: string | null, Question8Str?: string | null, Question9Str?: string | null, Question10Str?: string | null, Question10OtherText?: string | null, Success?: boolean | null } | null } | null } | null };

export type SubUserListItemFragment = { __typename?: 'SubUserInfo', Branch: string, MailAddress: string };

export type GetSubUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubUserListQuery = { __typename?: 'Query', GetSubUserList?: { __typename?: 'SubUserList', TotalCount: number, Data?: Array<{ __typename?: 'SubUserInfo', Branch: string, MailAddress: string } | null> | null } | null };

export type AddSubUserMutationVariables = Exact<{
  input?: InputMaybe<AddSubUserParam>;
}>;


export type AddSubUserMutation = { __typename?: 'Mutation', AddSubUser?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type DeleteSubUserMutationVariables = Exact<{
  input?: InputMaybe<DeleteSubUserParam>;
}>;


export type DeleteSubUserMutation = { __typename?: 'Mutation', DeleteSubUser?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type ApplicationItemFragment = { __typename?: 'ApplicationInfo', ID: string, Symbol: string, SymbolName: string, SymbolShortName: string, Status: number, ApplicationAmount: number, ApplicationDate: string, Linkable: boolean, Unit: string, AssetType: number };

export type GetApplicationListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetApplicationListQuery = { __typename?: 'Query', GetApplicationList?: { __typename?: 'ApplicationList', TotalCount: number, Data?: Array<{ __typename?: 'ApplicationInfo', ID: string, Symbol: string, SymbolName: string, SymbolShortName: string, Status: number, ApplicationAmount: number, ApplicationDate: string, Linkable: boolean, Unit: string, AssetType: number } | null> | null } | null };

export type GetApplicationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetApplicationQuery = { __typename?: 'Query', GetApplication?: { __typename?: 'ApplicationInfo', ID: string, Symbol: string, SymbolName: string, SymbolShortName: string, Status: number, ApplicationAmount: number, ApplicationDate: string, Linkable: boolean, Unit: string, AssetType: number } | null };

export type GetApplicationAmountQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetApplicationAmountQuery = { __typename?: 'Query', GetApplication?: { __typename?: 'ApplicationInfo', ApplicationAmount: number } | null };

export type PositionListItemFragment = { __typename?: 'PositionInfo', Symbol: string, SymbolName: string, SymbolShortName: string, TenantName: string, PaLDistMonth: Array<string>, InitialExchangeRate: number, InvestmentAmountDollar: number, InvestmentAmountYen: number, Status: number, ContractDate?: string | null, ProductType: number, PurchaseOptionDate: string, LeaseEndDate?: string | null, Linkable: boolean, HasIssuanceDoc: boolean };

export type GetPositionListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetPositionListQuery = { __typename?: 'Query', GetPositionList?: { __typename?: 'PositionList', TotalCount: number, Data?: Array<{ __typename?: 'PositionInfo', Symbol: string, SymbolName: string, SymbolShortName: string, TenantName: string, PaLDistMonth: Array<string>, InitialExchangeRate: number, InvestmentAmountDollar: number, InvestmentAmountYen: number, Status: number, ContractDate?: string | null, ProductType: number, PurchaseOptionDate: string, LeaseEndDate?: string | null, Linkable: boolean, HasIssuanceDoc: boolean } | null> | null } | null };

export type DomesticRealEstatePositionListItemFragment = { __typename?: 'DomesticRealEstatePositionInfo', Symbol: string, SymbolName: string, RealEstateName: string, TransferDate?: string | null, FirstTransferQuantity: number, FirstTransferRealEstatePrice: number, CurrentQuantity: number, CurrentRealEstatePrice: number, HoldingPeriod: string, TrustEndDate?: string | null, InheritanceTaxAssessment: number, InheritanceTaxAssessmentSmallResidence: number, DividendYield: number, BoxFolderAttachedID?: string | null, ProductType: number, Linkable: boolean, HasIssuanceDoc: boolean };

export type GetDomesticRealEstatePositionListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetDomesticRealEstatePositionListQuery = { __typename?: 'Query', GetDomesticRealEstatePositionList?: { __typename?: 'DomesticRealEstatePositionList', TotalCount: number, Data?: Array<{ __typename?: 'DomesticRealEstatePositionInfo', Symbol: string, SymbolName: string, RealEstateName: string, TransferDate?: string | null, FirstTransferQuantity: number, FirstTransferRealEstatePrice: number, CurrentQuantity: number, CurrentRealEstatePrice: number, HoldingPeriod: string, TrustEndDate?: string | null, InheritanceTaxAssessment: number, InheritanceTaxAssessmentSmallResidence: number, DividendYield: number, BoxFolderAttachedID?: string | null, ProductType: number, Linkable: boolean, HasIssuanceDoc: boolean } | null> | null } | null };

export type OverseasRealEstatePositionListItemFragment = { __typename?: 'OverseasRealEstatePositionInfo', Symbol: string, SymbolName: string, RealEstateName: string, PaLDistMonth: Array<string>, InitialExchangeRate: number, InvestmentAmountYen: number, ContractDate?: string | null, OperatingEndDate?: string | null, Status: string, ProjectedHoldingPeriod?: string | null, ProductType: number, Linkable: boolean, HasIssuanceDoc: boolean };

export type GetOverseasRealEstatePositionListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetOverseasRealEstatePositionListQuery = { __typename?: 'Query', GetOverseasRealEstatePositionList?: { __typename?: 'OverseasRealEstatePositionList', TotalCount: number, Data?: Array<{ __typename?: 'OverseasRealEstatePositionInfo', Symbol: string, SymbolName: string, RealEstateName: string, PaLDistMonth: Array<string>, InitialExchangeRate: number, InvestmentAmountYen: number, ContractDate?: string | null, OperatingEndDate?: string | null, Status: string, ProjectedHoldingPeriod?: string | null, ProductType: number, Linkable: boolean, HasIssuanceDoc: boolean } | null> | null } | null };

export type ConfirmApplySymbolMutationVariables = Exact<{
  input?: InputMaybe<ApplySymbolParam>;
}>;


export type ConfirmApplySymbolMutation = { __typename?: 'Mutation', ApplySymbol?: { __typename?: 'ApplySymbolResult', Code: number, Message?: string | null, PDFData?: string | null, ID?: string | null } | null };

export type ApplySymbolMutationVariables = Exact<{
  input?: InputMaybe<ApplySymbolParam>;
}>;


export type ApplySymbolMutation = { __typename?: 'Mutation', ApplySymbol?: { __typename?: 'ApplySymbolResult', Code: number, Message?: string | null, PDFData?: string | null, ID?: string | null } | null };

export type SendContactMutationVariables = Exact<{
  input?: InputMaybe<SendContactParam>;
}>;


export type SendContactMutation = { __typename?: 'Mutation', SendContact?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetIssuanceDocumentFolderListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIssuanceDocumentFolderListQuery = { __typename?: 'Query', GetIssuanceDocumentFolderList?: { __typename?: 'IssuanceDocumentFolderList', TotalCount: number, Own?: { __typename?: 'IssuanceDocumentFolderInfo', ID: string, Name: string, HasChildFolder?: boolean | null } | null, Data?: Array<{ __typename?: 'IssuanceDocumentFolderInfo', ID: string, Name: string, HasChildFolder?: boolean | null } | null> | null } | null };

export type GetIssuanceDocumentFileListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIssuanceDocumentFileListQuery = { __typename?: 'Query', GetIssuanceDocumentFileList?: { __typename?: 'IssuanceDocumentFileList', TotalCount: number, Data?: Array<{ __typename?: 'IssuanceDocumentFileInfo', ID: string, FileName: string, DisplayName: string, IssueDate: string } | null> | null } | null };

export type GetIssuanceDocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetIssuanceDocumentQuery = { __typename?: 'Query', GetIssuanceDocument?: { __typename?: 'IssuanceDocument', Data: string } | null };

export type GetPdfInfoQueryVariables = Exact<{
  pdfName: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
}>;


export type GetPdfInfoQuery = { __typename?: 'Query', GetPdfInfo?: { __typename?: 'PdfInfo', PdfData: string, ConsentDate: string } | null };

export type GetContractInfoQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetContractInfoQuery = { __typename?: 'Query', GetContractInfo?: { __typename?: 'ContractInfo', Code: number, Message?: string | null, Details?: { __typename?: 'ContractDetailInfo', Symbol: string, SymbolName: string, ProductType: number, ApplicationAmount: number, PaymentDate: string, AccruedInterest?: number | null, TotalTransferFee: number, PayeeBankName: string, PayeeBankBranchName: string, PayeeBankAccountTypeName: string, PayeeBankAccount: string, PayeeBankAccountHolderName: string, PayeeBankAccountHolderNameKana: string, Status: number, ExpensesTotal?: number | null, ContractAgreementDocumentData: string, TransferRequestFormDocumentInfo?: { __typename?: 'IssuanceDocumentFileInfo', ID: string, FileName: string, DisplayName: string, IssueDate: string } | null, AssignmentAgreementDocumentInfo?: { __typename?: 'IssuanceDocumentFileInfo', ID: string, FileName: string, DisplayName: string, IssueDate: string } | null, ContractAgreementDocumentInfo?: { __typename?: 'IssuanceDocumentFileInfo', ID: string, FileName: string, DisplayName: string, IssueDate: string } | null, TransferConsentDocumentInfo?: { __typename?: 'IssuanceDocumentFileInfo', ID: string, FileName: string, DisplayName: string, IssueDate: string } | null } | null } | null };

export type SignContractMutationVariables = Exact<{
  input?: InputMaybe<SignContractParam>;
}>;


export type SignContractMutation = { __typename?: 'Mutation', SignContract?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type AccountFragment = { __typename?: 'AccountInfo', Branch: string, ChangedPassword?: boolean | null, LastLoginDateTime?: string | null, SendSMSMessage?: string | null, AccountType?: number | null, IsElderly?: boolean | null, KFW8BenE?: boolean | null, KFFatca?: boolean | null, IsInvested: boolean, Compatible?: { __typename?: 'CompatibleInfo', LeaseFund?: boolean | null, DomesticRealEstate?: boolean | null, OverseasRealEstate?: boolean | null } | null, ApplicationStatus?: { __typename?: 'ApplicationStatusInfo', HasAnsweredDividendAccount: boolean, HasValidFatcaAnswer?: boolean | null, HasAnsweredInvoiceNumber: boolean, HasValidPEPsAnswer: boolean } | null };

export type GetAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountInfoQuery = { __typename?: 'Query', GetAccountInfo?: { __typename?: 'AccountInfo', Branch: string, ChangedPassword?: boolean | null, LastLoginDateTime?: string | null, SendSMSMessage?: string | null, AccountType?: number | null, IsElderly?: boolean | null, KFW8BenE?: boolean | null, KFFatca?: boolean | null, IsInvested: boolean, Compatible?: { __typename?: 'CompatibleInfo', LeaseFund?: boolean | null, DomesticRealEstate?: boolean | null, OverseasRealEstate?: boolean | null } | null, ApplicationStatus?: { __typename?: 'ApplicationStatusInfo', HasAnsweredDividendAccount: boolean, HasValidFatcaAnswer?: boolean | null, HasAnsweredInvoiceNumber: boolean, HasValidPEPsAnswer: boolean } | null } | null };

export type GetAccountTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountTypeQuery = { __typename?: 'Query', GetAccountInfo?: { __typename?: 'AccountInfo', AccountType?: number | null } | null };

export type GetCompatibleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompatibleQuery = { __typename?: 'Query', GetAccountInfo?: { __typename?: 'AccountInfo', Compatible?: { __typename?: 'CompatibleInfo', LeaseFund?: boolean | null, DomesticRealEstate?: boolean | null, OverseasRealEstate?: boolean | null } | null } | null };

export type GetSendSmsMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSendSmsMessageQuery = { __typename?: 'Query', GetAccountInfo?: { __typename?: 'AccountInfo', SendSMSMessage?: string | null } | null };

export type GetPreApplicationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreApplicationStatusQuery = { __typename?: 'Query', GetAccountInfo?: { __typename?: 'AccountInfo', IsElderly?: boolean | null, ApplicationStatus?: { __typename?: 'ApplicationStatusInfo', HasAnsweredDividendAccount: boolean, HasValidFatcaAnswer?: boolean | null, HasAnsweredInvoiceNumber: boolean, HasValidPEPsAnswer: boolean } | null } | null };

export type GetAgreementDocumentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementDocumentQuery = { __typename?: 'Query', GetAgreementDocument?: { __typename?: 'AgreementDocumentList', Data?: Array<{ __typename?: 'AgreementDocumentInfo', Read: boolean, Type: number, TermsAndConditionsURL: string, ComparisonTableURL: string, ChangeDetailsURL: string } | null> | null } | null };

export type AgreeDocumentMutationVariables = Exact<{
  input?: InputMaybe<AgreeDocumentParam>;
}>;


export type AgreeDocumentMutation = { __typename?: 'Mutation', AgreeDocument?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetAdvanceQuestionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAdvanceQuestionQuery = { __typename?: 'Query', GetAdvanceQuestion?: { __typename?: 'AdvanceQuestionValue', HaveEKYCDocument: boolean, DealerMailAddress: string, CanTakePicture: boolean, RepresentAndDealerAreSame?: boolean | null, AdvanceNationality?: boolean | null, AdvanceCountryOfResidence?: boolean | null, Birthdate?: string | null } | null };

export type AdvanceQuestionMutationVariables = Exact<{
  input?: InputMaybe<AdvanceQuestionParam>;
}>;


export type AdvanceQuestionMutation = { __typename?: 'Mutation', AdvanceQuestion?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type AgreeDisclosureStatementMutationVariables = Exact<{
  input?: InputMaybe<AgreeDisclosureStatementParam>;
}>;


export type AgreeDisclosureStatementMutation = { __typename?: 'Mutation', AgreeDisclosureStatement?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetAddressInfoQueryVariables = Exact<{
  postCode: Scalars['String']['input'];
}>;


export type GetAddressInfoQuery = { __typename?: 'Query', GetAddressInfo?: { __typename?: 'AddressInfo', CityCountry?: string | null, Prefecture?: string | null, TownStreetAddress?: string | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input?: InputMaybe<ChangePasswordParam>;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', ChangePassword?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type OpenAccountMutationVariables = Exact<{
  input?: InputMaybe<OpenAccountParam>;
}>;


export type OpenAccountMutation = { __typename?: 'Mutation', OpenAccount?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type ChangeAccountInfoMutationVariables = Exact<{
  input?: InputMaybe<ChangeAccountInfoParam>;
}>;


export type ChangeAccountInfoMutation = { __typename?: 'Mutation', ChangeAccountInfo?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type ChangeDomesticRealEstateApplicationMutationVariables = Exact<{
  input?: InputMaybe<ChangeDomesticRealEstateApplicationParam>;
}>;


export type ChangeDomesticRealEstateApplicationMutation = { __typename?: 'Mutation', ChangeDomesticRealEstateApplication?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetAccountDetailInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountDetailInfoQuery = { __typename?: 'Query', GetAccountDetailInfo?: { __typename?: 'AccountDetailInfo', RepresentAndDealerAreSame?: boolean | null, CorporateNumber?: string | null, Name?: string | null, Furigana?: string | null, CorporateAddressConfirm?: boolean | null, RegisteredPostCode?: string | null, RegisteredPrefecture?: string | null, RegisteredCityCountry?: string | null, RegisteredTownStreetAddress?: string | null, RegisteredBuildingNameAndRoomNumber?: string | null, CorporateSettlementMonth?: Array<number | null> | null, CorporateSettlementDay?: number | null, CorporateEstablishmentDate?: string | null, CorporateMainBusinessContent?: number | null, CorporateMainBusinessContentOtherText?: string | null, CorporateOtherBusinessContent?: number | null, CorporateOtherBusinessContentOtherText?: string | null, CorporateCapital?: number | null, CorporateNumberOfEmployees?: number | null, CorporateHomepage?: string | null, ElectronicDocumentAgreement?: boolean | null, LeaseFundPurpose?: Array<number | null> | null, LeaseFundPurposeOtherText?: string | null, DomesticRealEstatePurpose?: Array<number | null> | null, DomesticRealEstatePurposeOtherText?: string | null, OverseasRealEstatePurpose?: Array<number | null> | null, OverseasRealEstatePurposeOtherText?: string | null, ContactPhoneNumber?: string | null, ContactFaxNumber?: string | null, RepresentFirstName?: string | null, RepresentLastName?: string | null, RepresentFirstNameKana?: string | null, RepresentLastNameKana?: string | null, RepresentBirthDay?: string | null, RepresentPostCode?: string | null, RepresentPrefecture?: string | null, RepresentCityCountry?: string | null, RepresentTownStreetAddress?: string | null, RepresentBuildingNameAndRoomNumber?: string | null, RepresentMobilePhoneNumber?: string | null, RepresentPosition?: string | null, RepresentMailAddress?: string | null, DealerFirstName?: string | null, DealerLastName?: string | null, DealerFirstNameKana?: string | null, DealerLastNameKana?: string | null, DealerBirthDay?: string | null, DealerPostCode?: string | null, DealerPrefecture?: string | null, DealerCityCountry?: string | null, DealerTownStreetAddress?: string | null, DealerBuildingNameAndRoomNumber?: string | null, DealerMobilePhoneNumber?: string | null, DealerMailAddress?: string | null, DealerDepartment?: string | null, DealerOtherDepartment?: string | null, DealerPosition?: string | null, AboutRuler1?: number | null, Ruler1Name?: string | null, Ruler1BirthDay?: string | null, Ruler1Relationship?: number | null, Ruler1MailAddress?: string | null, Ruler1PostCode?: string | null, Ruler1Prefecture?: string | null, Ruler1CityCountry?: string | null, Ruler1TownStreetAddress?: string | null, Ruler1BuildingNameAndRoomNumber?: string | null, Ruler1ImportantPublicWorker?: boolean | null, AboutRuler2?: number | null, Ruler2Name?: string | null, Ruler2BirthDay?: string | null, Ruler2Relationship?: number | null, Ruler2MailAddress?: string | null, Ruler2PostCode?: string | null, Ruler2Prefecture?: string | null, Ruler2CityCountry?: string | null, Ruler2TownStreetAddress?: string | null, Ruler2BuildingNameAndRoomNumber?: string | null, Ruler2ImportantPublicWorker?: boolean | null, AboutRuler3?: number | null, Ruler3Name?: string | null, Ruler3BirthDay?: string | null, Ruler3Relationship?: number | null, Ruler3MailAddress?: string | null, Ruler3PostCode?: string | null, Ruler3Prefecture?: string | null, Ruler3CityCountry?: string | null, Ruler3TownStreetAddress?: string | null, Ruler3BuildingNameAndRoomNumber?: string | null, Ruler3ImportantPublicWorker?: boolean | null, InvestorCategoryInfo?: Array<number | null> | null, ConfirmResponsibility?: boolean | null, TwoFactorAuthenticationType?: number | null, InvoiceNumber?: string | null, Fatca?: number | null, FatcaOtherText?: string | null, PostCode?: string | null, Prefecture?: string | null, CityCountry?: string | null, TownStreetAddress?: string | null, BuildingNameAndRoomNumber?: string | null, Occupation?: Array<number | null> | null, OccupationOtherText?: string | null, PersonalMainBusinessContent?: number | null, PersonalMainBusinessContentOtherText?: string | null, PersonalOtherBusinessContent?: number | null, PersonalOtherBusinessContentOtherText?: string | null, ImportantPublicWorker?: number | null, ImportantPublicWorkerOtherReason?: string | null, TransferBankName?: string | null, TransferBranchName?: string | null, TransferAccountType?: number | null, TransferAccountNumber?: string | null, TransferAccountHolderName?: string | null } | null };

export type GetDateTimeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDateTimeQuery = { __typename?: 'Query', GetDateTime?: { __typename?: 'DateTimeInfo', Current?: string | null } | null };

export type SendPreContractNotifyMutationVariables = Exact<{
  input?: InputMaybe<SendPreContractNotifyParam>;
}>;


export type SendPreContractNotifyMutation = { __typename?: 'Mutation', SendPreContractNotify?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', Logout?: { __typename?: 'ExecuteResult', Code: number, Message?: string | null } | null };

export type GetFaqListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  symbolProductType: Scalars['Int']['input'];
}>;


export type GetFaqListQuery = { __typename?: 'Query', GetFaqList?: { __typename?: 'FaqList', TotalCount: number, Data?: Array<{ __typename?: 'FaqInfo', ID: number, Title: string, QaList?: Array<{ __typename?: 'QaValuesInfo', QAID: number, Question: string, Answer: string } | null> | null } | null> | null } | null };

export type FaqListItemFragment = { __typename?: 'FaqInfo', ID: number, Title: string, QaList?: Array<{ __typename?: 'QaValuesInfo', QAID: number, Question: string, Answer: string } | null> | null };

export type GetFaqContentsListQueryVariables = Exact<{
  count: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  symbolProductType: Scalars['Int']['input'];
}>;


export type GetFaqContentsListQuery = { __typename?: 'Query', GetFaqContentsList?: { __typename?: 'FaqContentsList', TotalCount: number, Data?: Array<{ __typename?: 'QaValuesInfo', QAID: number, Question: string, Answer: string } | null> | null } | null };

export type FaqContentsListItemFragment = { __typename?: 'QaValuesInfo', QAID: number, Question: string, Answer: string };

export type BrokerListItemFragment = { __typename?: 'BrokerInfo', BrokerCode?: string | null, BrokerName?: string | null, BranchCode?: string | null, BranchName?: string | null };

export type GetBrokerInfoQueryVariables = Exact<{
  brokerName?: InputMaybe<Scalars['String']['input']>;
  brokerCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBrokerInfoQuery = { __typename?: 'Query', GetBrokerInfo?: { __typename?: 'BrokerList', TotalCount: number, Data?: Array<{ __typename?: 'BrokerInfo', BrokerCode?: string | null, BrokerName?: string | null, BranchCode?: string | null, BranchName?: string | null } | null> | null } | null };

export type GetBrokerBranchInfoQueryVariables = Exact<{
  brokerName?: InputMaybe<Scalars['String']['input']>;
  branchCode?: InputMaybe<Scalars['String']['input']>;
  branchName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBrokerBranchInfoQuery = { __typename?: 'Query', GetBrokerBranchInfo?: { __typename?: 'BrokerList', TotalCount: number, Data?: Array<{ __typename?: 'BrokerInfo', BrokerCode?: string | null, BrokerName?: string | null, BranchCode?: string | null, BranchName?: string | null } | null> | null } | null };

export const NotificationListItemFragmentDoc = gql`
    fragment NotificationListItem on NotificationInfo {
  ID
  DeliveryType
  DeliveryTarget
  Title
  Confirmed
  PublishStartDate
}
    `;
export const SubUserListItemFragmentDoc = gql`
    fragment SubUserListItem on SubUserInfo {
  Branch
  MailAddress
}
    `;
export const ApplicationItemFragmentDoc = gql`
    fragment ApplicationItem on ApplicationInfo {
  ID
  Symbol
  SymbolName
  SymbolShortName
  Status
  ApplicationAmount
  ApplicationDate
  Linkable
  Unit
  AssetType
}
    `;
export const PositionListItemFragmentDoc = gql`
    fragment PositionListItem on PositionInfo {
  Symbol
  SymbolName
  SymbolShortName
  TenantName
  PaLDistMonth
  InitialExchangeRate
  InvestmentAmountDollar
  InvestmentAmountYen
  Status
  ContractDate
  ProductType
  PurchaseOptionDate
  LeaseEndDate
  Linkable
  HasIssuanceDoc
}
    `;
export const DomesticRealEstatePositionListItemFragmentDoc = gql`
    fragment DomesticRealEstatePositionListItem on DomesticRealEstatePositionInfo {
  Symbol
  SymbolName
  RealEstateName
  TransferDate
  FirstTransferQuantity
  FirstTransferRealEstatePrice
  CurrentQuantity
  CurrentRealEstatePrice
  HoldingPeriod
  TrustEndDate
  InheritanceTaxAssessment
  InheritanceTaxAssessmentSmallResidence
  DividendYield
  BoxFolderAttachedID
  ProductType
  Linkable
  HasIssuanceDoc
}
    `;
export const OverseasRealEstatePositionListItemFragmentDoc = gql`
    fragment OverseasRealEstatePositionListItem on OverseasRealEstatePositionInfo {
  Symbol
  SymbolName
  RealEstateName
  PaLDistMonth
  InitialExchangeRate
  InvestmentAmountYen
  ContractDate
  OperatingEndDate
  Status
  ProjectedHoldingPeriod
  ProductType
  Linkable
  HasIssuanceDoc
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on AccountInfo {
  Branch
  ChangedPassword
  LastLoginDateTime
  Compatible {
    LeaseFund
    DomesticRealEstate
    OverseasRealEstate
  }
  SendSMSMessage
  AccountType
  ApplicationStatus {
    HasAnsweredDividendAccount
    HasValidFatcaAnswer
    HasAnsweredInvoiceNumber
    HasValidPEPsAnswer
  }
  IsElderly
  KFW8BenE
  KFFatca
  IsInvested
}
    `;
export const FaqListItemFragmentDoc = gql`
    fragment FaqListItem on FaqInfo {
  ID
  Title
  QaList {
    QAID
    Question
    Answer
  }
}
    `;
export const FaqContentsListItemFragmentDoc = gql`
    fragment FaqContentsListItem on QaValuesInfo {
  QAID
  Question
  Answer
}
    `;
export const BrokerListItemFragmentDoc = gql`
    fragment BrokerListItem on BrokerInfo {
  BrokerCode
  BrokerName
  BranchCode
  BranchName
}
    `;
export const LoginDocument = gql`
    mutation Login($input: LoginParam) {
  Login(input: $input) {
    Code
    Message
    ProvisionalToken
    DisplayText
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const HomeDocument = gql`
    query Home($notificationCount: Int!) {
  AllNotificationList: GetNotificationList(
    count: $notificationCount
    page: 1
    deliveryTarget: 1
  ) {
    TotalCount
    Data {
      ...NotificationListItem
    }
  }
  PersonalNotificationList: GetNotificationList(
    count: $notificationCount
    page: 1
    deliveryTarget: 2
  ) {
    TotalCount
    Data {
      ...NotificationListItem
    }
  }
}
    ${NotificationListItemFragmentDoc}`;

export function useHomeQuery(options: Omit<Urql.UseQueryArgs<HomeQueryVariables>, 'query'>) {
  return Urql.useQuery<HomeQuery, HomeQueryVariables>({ query: HomeDocument, ...options });
};
export const GetNotificationListDocument = gql`
    query GetNotificationList($count: Int!, $page: Int!, $deliveryTarget: Int) {
  GetNotificationList(count: $count, page: $page, deliveryTarget: $deliveryTarget) {
    TotalCount
    Data {
      ...NotificationListItem
    }
  }
}
    ${NotificationListItemFragmentDoc}`;

export function useGetNotificationListQuery(options: Omit<Urql.UseQueryArgs<GetNotificationListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationListQuery, GetNotificationListQueryVariables>({ query: GetNotificationListDocument, ...options });
};
export const GetNotificationInfoDocument = gql`
    query GetNotificationInfo($id: String!) {
  GetNotificationInfo(id: $id) {
    ID
    DeliveryType
    DeliveryTarget
    Title
    Contents
    Confirmed
    PublishStartDate
    ConfirmDateTime
  }
}
    `;

export function useGetNotificationInfoQuery(options: Omit<Urql.UseQueryArgs<GetNotificationInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationInfoQuery, GetNotificationInfoQueryVariables>({ query: GetNotificationInfoDocument, ...options });
};
export const ReadNotificationDocument = gql`
    mutation ReadNotification($input: ReadNotificationParam) {
  ReadNotification(input: $input) {
    Code
    Message
  }
}
    `;

export function useReadNotificationMutation() {
  return Urql.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument);
};
export const SmsCertificateDocument = gql`
    mutation SMSCertificate($input: SMSCertificateParam) {
  SMSCertificate(input: $input) {
    Code
    Message
    Token
  }
}
    `;

export function useSmsCertificateMutation() {
  return Urql.useMutation<SmsCertificateMutation, SmsCertificateMutationVariables>(SmsCertificateDocument);
};
export const SendSmsDocument = gql`
    mutation SendSMS($input: SendSMSParam) {
  SendSMS(input: $input) {
    Code
    Message
    ProvisionalToken
  }
}
    `;

export function useSendSmsMutation() {
  return Urql.useMutation<SendSmsMutation, SendSmsMutationVariables>(SendSmsDocument);
};
export const ReissuePasswordDocument = gql`
    mutation ReissuePassword($input: ReissuePasswordParam) {
  ReissuePassword(input: $input) {
    Code
    Message
    ProvisionalToken
  }
}
    `;

export function useReissuePasswordMutation() {
  return Urql.useMutation<ReissuePasswordMutation, ReissuePasswordMutationVariables>(ReissuePasswordDocument);
};
export const GetSymbolListDocument = gql`
    query GetSymbolList($count: Int!, $page: Int!, $productType: Int!) {
  GetSymbolList(count: $count, page: $page, productType: $productType) {
    TotalCount
    Data {
      Symbol
      SymbolShortName
      SymbolName
      SymbolType
      ProductType
      Status
      ImageUrl
      TenantName
      PaLDistMonth
      FirstYearDeductionRate
      LeaseStartDate
      MinimumInvestmentAmount
      TotalInvestmentAmount
      PurchaseOptions {
        Date
        Elapsed
      }
      PreContractDocumentURL
      SimplePreContractDocumentURL
      TransferStartDate
      TransferEndDate
      TransferInterest
      TransferInterestPattern
      DisplayDate1FromBySettlement
      DisplayDate1ToBySettlement
      DisplayDate2FromBySettlement
      DisplayDate2ToBySettlement
      TenantSummary
      AccruedInterest
      AmountOptions
      MaxInvestmentAmount
      SalesUnitCtrl
    }
  }
}
    `;

export function useGetSymbolListQuery(options: Omit<Urql.UseQueryArgs<GetSymbolListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSymbolListQuery, GetSymbolListQueryVariables>({ query: GetSymbolListDocument, ...options });
};
export const GetSymbolInfoDocument = gql`
    query GetSymbolInfo($symbol: String!) {
  GetSymbolInfo(symbol: $symbol) {
    Symbol
    SymbolShortName
    SymbolName
    SymbolType
    ProductType
    Status
    ImageUrl
    TenantName
    PaLDistMonth
    FirstYearDeductionRate
    LeaseStartDate
    MinimumInvestmentAmount
    TotalInvestmentAmount
    PurchaseOptions {
      Date
      Elapsed
    }
    PreContractDocumentURL
    SimplePreContractDocumentURL
    TransferStartDate
    TransferEndDate
    TransferInterest
    TransferInterestPattern
    Tradable
    DisplayDate1FromBySettlement
    DisplayDate1ToBySettlement
    DisplayDate2FromBySettlement
    DisplayDate2ToBySettlement
    TenantSummary
    AccruedInterest
    AmountOptions
    BoundaryAmount
    LowerRate
    UpperRate
    MaxInvestmentAmount
    SalesUnitCtrl
  }
}
    `;

export function useGetSymbolInfoQuery(options: Omit<Urql.UseQueryArgs<GetSymbolInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSymbolInfoQuery, GetSymbolInfoQueryVariables>({ query: GetSymbolInfoDocument, ...options });
};
export const GetOverseasRealEstateSymbolListDocument = gql`
    query GetOverseasRealEstateSymbolList($count: Int!, $page: Int!, $productType: Int!) {
  GetOverseasRealEstateSymbolList(
    count: $count
    page: $page
    productType: $productType
  ) {
    TotalCount
    Data {
      Symbol
      SymbolName
      SymbolShortName
      Status
      PaLDistMonth
      MinimumInvestmentAmount
      ImageUrl
      PreContractDocumentURL
      SimplePreContractDocumentURL
      TransferStartDate
      TransferEndDate
      TransferInterest
      TransferInterestPattern
      ApplicationLimitDate
      DisplayDate1FromBySettlement
      DisplayDate1ToBySettlement
      DisplayDate2FromBySettlement
      DisplayDate2ToBySettlement
      TotalDocumentURL
      InitialYearExpenseRate
      DurationOfPartnership
      ProductType
      CompletionYear
      BuildingType
      BuildingName
      Location
      BusinessStartDate
      FinalBusinessProfitRate
      HoldingPeriod
      Tradable
      AmountOptions
      MaxInvestmentAmount
      AccruedInterest
      SalesUnitCtrl
    }
  }
}
    `;

export function useGetOverseasRealEstateSymbolListQuery(options: Omit<Urql.UseQueryArgs<GetOverseasRealEstateSymbolListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOverseasRealEstateSymbolListQuery, GetOverseasRealEstateSymbolListQueryVariables>({ query: GetOverseasRealEstateSymbolListDocument, ...options });
};
export const GetOverseasRealEstateSymbolInfoDocument = gql`
    query GetOverseasRealEstateSymbolInfo($symbol: String!) {
  GetOverseasRealEstateSymbolInfo(symbol: $symbol) {
    Symbol
    SymbolName
    SymbolShortName
    Status
    PaLDistMonth
    MinimumInvestmentAmount
    ImageUrl
    PreContractDocumentURL
    SimplePreContractDocumentURL
    TransferStartDate
    TransferEndDate
    TransferInterest
    TransferInterestPattern
    ApplicationLimitDate
    DisplayDate1FromBySettlement
    DisplayDate1ToBySettlement
    DisplayDate2FromBySettlement
    DisplayDate2ToBySettlement
    TotalDocumentURL
    InitialYearExpenseRate
    DurationOfPartnership
    ProductType
    CompletionYear
    BuildingType
    BuildingName
    Location
    BusinessStartDate
    FinalBusinessProfitRate
    HoldingPeriod
    Tradable
    AmountOptions
    MaxInvestmentAmount
    AccruedInterest
    SalesUnitCtrl
    BoundaryAmount
    LowerRate
    UpperRate
  }
}
    `;

export function useGetOverseasRealEstateSymbolInfoQuery(options: Omit<Urql.UseQueryArgs<GetOverseasRealEstateSymbolInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOverseasRealEstateSymbolInfoQuery, GetOverseasRealEstateSymbolInfoQueryVariables>({ query: GetOverseasRealEstateSymbolInfoDocument, ...options });
};
export const GetDomesticRealEstateSymbolListDocument = gql`
    query GetDomesticRealEstateSymbolList($count: Int!, $page: Int!, $productType: Int!) {
  GetDomesticRealEstateSymbolList(
    count: $count
    page: $page
    productType: $productType
  ) {
    TotalCount
    Data {
      Symbol
      WebOrderLimitQuantity
      RemainingQuantity
      Status
      DividendPeriod
      CompressionRate
      MaxInvestmentQuantity
      AmountOptions
      BuiltYear
      GrossYield
      DividendYield
      SalesUnit
      SalesUnitCtrl
      ImageURL
      SimplePreContractDocumentURL
      DetailURL
      InheritanceTaxAssessmentURL
      LocationMapURL
      ApplicationLimitDate
      TransferDate
      ITExplanationMinDate
      ITExplanationMaxDate
      ITExplanationLimitDate
      ContractURLLimitDate
      ProductName
      OriginalContractBuildingName
      SalesQuantity
      TotalSalesQuantity
      RealEstatePriceEquivalent
      ConsumptionTaxAmount
      RepairReserveFundEquivalent
      RequiredWorkingCapitalReserveEquivalent
      RealEstateBeneficiaryRightPrice
      Location
      SalesPlotAnnotationText
      Tradable
    }
  }
}
    `;

export function useGetDomesticRealEstateSymbolListQuery(options: Omit<Urql.UseQueryArgs<GetDomesticRealEstateSymbolListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDomesticRealEstateSymbolListQuery, GetDomesticRealEstateSymbolListQueryVariables>({ query: GetDomesticRealEstateSymbolListDocument, ...options });
};
export const GetDomesticRealEstateSymbolInfoDocument = gql`
    query GetDomesticRealEstateSymbolInfo($symbol: String!) {
  GetDomesticRealEstateSymbolInfo(symbol: $symbol) {
    Symbol
    WebOrderLimitQuantity
    RemainingQuantity
    Status
    DividendPeriod
    CompressionRate
    MaxInvestmentQuantity
    AmountOptions
    BuiltYear
    GrossYield
    DividendYield
    SalesUnit
    SalesUnitCtrl
    ImageURL
    SimplePreContractDocumentURL
    DetailURL
    InheritanceTaxAssessmentURL
    LocationMapURL
    ApplicationLimitDate
    TransferDate
    ITExplanationMinDate
    ITExplanationMaxDate
    ITExplanationLimitDate
    ContractURLLimitDate
    ProductName
    OriginalContractBuildingName
    SalesQuantity
    TotalSalesQuantity
    RealEstatePriceEquivalent
    ConsumptionTaxAmount
    RepairReserveFundEquivalent
    RequiredWorkingCapitalReserveEquivalent
    RealEstateBeneficiaryRightPrice
    Location
    SalesPlotAnnotationText
    Tradable
  }
}
    `;

export function useGetDomesticRealEstateSymbolInfoQuery(options: Omit<Urql.UseQueryArgs<GetDomesticRealEstateSymbolInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDomesticRealEstateSymbolInfoQuery, GetDomesticRealEstateSymbolInfoQueryVariables>({ query: GetDomesticRealEstateSymbolInfoDocument, ...options });
};
export const AnswerCompatibilityDocument = gql`
    mutation AnswerCompatibility($input: AnswerCompatibilityParam) {
  AnswerCompatibility(input: $input) {
    Code
    Message
  }
}
    `;

export function useAnswerCompatibilityMutation() {
  return Urql.useMutation<AnswerCompatibilityMutation, AnswerCompatibilityMutationVariables>(AnswerCompatibilityDocument);
};
export const AnswerRecorderDocument = gql`
    mutation AnswerRecorder($input: AnswerRecorderParam) {
  AnswerRecorder(input: $input) {
    Code
    Message
  }
}
    `;

export function useAnswerRecorderMutation() {
  return Urql.useMutation<AnswerRecorderMutation, AnswerRecorderMutationVariables>(AnswerRecorderDocument);
};
export const GetCompatibilityDocument = gql`
    query GetCompatibility($conditionType: Int!, $assetType: Int!) {
  GetCompatibility(conditionType: $conditionType, assetType: $assetType) {
    LeaseFundAnswer {
      WebAnswer {
        Question1
        Question2
        Question3
        Question4
        Question5
        Question6
        Question7
        Question8
        Question1Str
        Question2Str
        Question3Str
        Question4Str
        Question5Str
        Question6Str
        Question7Str
        Question8OtherText
        Success
      }
      InPersonAnswer {
        Question1
        Question2
        Question3
        Question4
        Question5
        Question6
        Question7
        Question8
        Question1Str
        Question2Str
        Question3Str
        Question4Str
        Question5Str
        Question6Str
        Question7Str
        Question8Str
        Question9Str
        Question9OtherText
        Success
      }
    }
    DomesticRealEstateAnswer {
      CorporateWebAnswer {
        Question1
        Question2
        Question3
        Question4
        Question5
        Question6
        Question7
        Question1Str
        Question2Str
        Question3Str
        Question4Str
        Question5Str
        Question6Str
        Success
      }
      PersonalWebAnswer {
        Question1
        Question2
        Question3
        Question4
        Question5
        Question6
        Question7
        Question8
        Question9
        Question1Str
        Question2Str
        Question3Str
        Question4Str
        Question5Str
        Question6Str
        Question7Str
        Question8Str
        Success
      }
      InPersonAnswer {
        Question1
        Question2
        Question3
        Question4
        Question5
        Question6
        Question7
        Question1Str
        Question2Str
        Question3Str
        Question4Str
        Question5Str
        Question6Str
        Question7Str
        Question8Str
        Question8OtherText
        Success
      }
    }
    OverseasRealEstateAnswer {
      WebAnswer {
        Question1
        Question2
        Question3
        Question4
        Question5
        Question6
        Question7
        Question8
        Question9
        Question1Str
        Question2Str
        Question3Str
        Question4Str
        Question5Str
        Question6Str
        Question7Str
        Question8Str
        Success
      }
      InPersonAnswer {
        Question1
        Question2
        Question3
        Question4
        Question5
        Question6
        Question7
        Question8
        Question9
        Question1Str
        Question2Str
        Question3Str
        Question4Str
        Question5Str
        Question6Str
        Question7Str
        Question8Str
        Question9Str
        Question10Str
        Question10OtherText
        Success
      }
    }
  }
}
    `;

export function useGetCompatibilityQuery(options: Omit<Urql.UseQueryArgs<GetCompatibilityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompatibilityQuery, GetCompatibilityQueryVariables>({ query: GetCompatibilityDocument, ...options });
};
export const GetSubUserListDocument = gql`
    query GetSubUserList {
  GetSubUserList {
    TotalCount
    Data {
      ...SubUserListItem
    }
  }
}
    ${SubUserListItemFragmentDoc}`;

export function useGetSubUserListQuery(options?: Omit<Urql.UseQueryArgs<GetSubUserListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSubUserListQuery, GetSubUserListQueryVariables>({ query: GetSubUserListDocument, ...options });
};
export const AddSubUserDocument = gql`
    mutation AddSubUser($input: AddSubUserParam) {
  AddSubUser(input: $input) {
    Code
    Message
  }
}
    `;

export function useAddSubUserMutation() {
  return Urql.useMutation<AddSubUserMutation, AddSubUserMutationVariables>(AddSubUserDocument);
};
export const DeleteSubUserDocument = gql`
    mutation DeleteSubUser($input: DeleteSubUserParam) {
  DeleteSubUser(input: $input) {
    Code
    Message
  }
}
    `;

export function useDeleteSubUserMutation() {
  return Urql.useMutation<DeleteSubUserMutation, DeleteSubUserMutationVariables>(DeleteSubUserDocument);
};
export const GetApplicationListDocument = gql`
    query GetApplicationList($count: Int!, $page: Int!) {
  GetApplicationList(count: $count, page: $page) {
    TotalCount
    Data {
      ...ApplicationItem
    }
  }
}
    ${ApplicationItemFragmentDoc}`;

export function useGetApplicationListQuery(options: Omit<Urql.UseQueryArgs<GetApplicationListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetApplicationListQuery, GetApplicationListQueryVariables>({ query: GetApplicationListDocument, ...options });
};
export const GetApplicationDocument = gql`
    query GetApplication($id: String!) {
  GetApplication(id: $id) {
    ...ApplicationItem
  }
}
    ${ApplicationItemFragmentDoc}`;

export function useGetApplicationQuery(options: Omit<Urql.UseQueryArgs<GetApplicationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetApplicationQuery, GetApplicationQueryVariables>({ query: GetApplicationDocument, ...options });
};
export const GetApplicationAmountDocument = gql`
    query GetApplicationAmount($id: String!) {
  GetApplication(id: $id) {
    ApplicationAmount
  }
}
    `;

export function useGetApplicationAmountQuery(options: Omit<Urql.UseQueryArgs<GetApplicationAmountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetApplicationAmountQuery, GetApplicationAmountQueryVariables>({ query: GetApplicationAmountDocument, ...options });
};
export const GetPositionListDocument = gql`
    query GetPositionList($count: Int!, $page: Int!) {
  GetPositionList(count: $count, page: $page) {
    TotalCount
    Data {
      ...PositionListItem
    }
  }
}
    ${PositionListItemFragmentDoc}`;

export function useGetPositionListQuery(options: Omit<Urql.UseQueryArgs<GetPositionListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPositionListQuery, GetPositionListQueryVariables>({ query: GetPositionListDocument, ...options });
};
export const GetDomesticRealEstatePositionListDocument = gql`
    query GetDomesticRealEstatePositionList($count: Int!, $page: Int!) {
  GetDomesticRealEstatePositionList(count: $count, page: $page) {
    TotalCount
    Data {
      ...DomesticRealEstatePositionListItem
    }
  }
}
    ${DomesticRealEstatePositionListItemFragmentDoc}`;

export function useGetDomesticRealEstatePositionListQuery(options: Omit<Urql.UseQueryArgs<GetDomesticRealEstatePositionListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDomesticRealEstatePositionListQuery, GetDomesticRealEstatePositionListQueryVariables>({ query: GetDomesticRealEstatePositionListDocument, ...options });
};
export const GetOverseasRealEstatePositionListDocument = gql`
    query GetOverseasRealEstatePositionList($count: Int!, $page: Int!) {
  GetOverseasRealEstatePositionList(count: $count, page: $page) {
    TotalCount
    Data {
      ...OverseasRealEstatePositionListItem
    }
  }
}
    ${OverseasRealEstatePositionListItemFragmentDoc}`;

export function useGetOverseasRealEstatePositionListQuery(options: Omit<Urql.UseQueryArgs<GetOverseasRealEstatePositionListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOverseasRealEstatePositionListQuery, GetOverseasRealEstatePositionListQueryVariables>({ query: GetOverseasRealEstatePositionListDocument, ...options });
};
export const ConfirmApplySymbolDocument = gql`
    mutation ConfirmApplySymbol($input: ApplySymbolParam) {
  ApplySymbol(input: $input) {
    Code
    Message
    PDFData
    ID
  }
}
    `;

export function useConfirmApplySymbolMutation() {
  return Urql.useMutation<ConfirmApplySymbolMutation, ConfirmApplySymbolMutationVariables>(ConfirmApplySymbolDocument);
};
export const ApplySymbolDocument = gql`
    mutation ApplySymbol($input: ApplySymbolParam) {
  ApplySymbol(input: $input) {
    Code
    Message
    PDFData
    ID
  }
}
    `;

export function useApplySymbolMutation() {
  return Urql.useMutation<ApplySymbolMutation, ApplySymbolMutationVariables>(ApplySymbolDocument);
};
export const SendContactDocument = gql`
    mutation SendContact($input: SendContactParam) {
  SendContact(input: $input) {
    Code
    Message
  }
}
    `;

export function useSendContactMutation() {
  return Urql.useMutation<SendContactMutation, SendContactMutationVariables>(SendContactDocument);
};
export const GetIssuanceDocumentFolderListDocument = gql`
    query GetIssuanceDocumentFolderList($count: Int!, $page: Int!, $id: String) {
  GetIssuanceDocumentFolderList(count: $count, page: $page, id: $id) {
    TotalCount
    Own {
      ID
      Name
      HasChildFolder
    }
    Data {
      ID
      Name
      HasChildFolder
    }
  }
}
    `;

export function useGetIssuanceDocumentFolderListQuery(options: Omit<Urql.UseQueryArgs<GetIssuanceDocumentFolderListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIssuanceDocumentFolderListQuery, GetIssuanceDocumentFolderListQueryVariables>({ query: GetIssuanceDocumentFolderListDocument, ...options });
};
export const GetIssuanceDocumentFileListDocument = gql`
    query GetIssuanceDocumentFileList($count: Int!, $page: Int!, $id: String, $keyword: String) {
  GetIssuanceDocumentFileList(
    count: $count
    page: $page
    id: $id
    keyword: $keyword
  ) {
    TotalCount
    Data {
      ID
      FileName
      DisplayName
      IssueDate
    }
  }
}
    `;

export function useGetIssuanceDocumentFileListQuery(options: Omit<Urql.UseQueryArgs<GetIssuanceDocumentFileListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIssuanceDocumentFileListQuery, GetIssuanceDocumentFileListQueryVariables>({ query: GetIssuanceDocumentFileListDocument, ...options });
};
export const GetIssuanceDocumentDocument = gql`
    query GetIssuanceDocument($id: String!) {
  GetIssuanceDocument(id: $id) {
    Data
  }
}
    `;

export function useGetIssuanceDocumentQuery(options: Omit<Urql.UseQueryArgs<GetIssuanceDocumentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetIssuanceDocumentQuery, GetIssuanceDocumentQueryVariables>({ query: GetIssuanceDocumentDocument, ...options });
};
export const GetPdfInfoDocument = gql`
    query GetPdfInfo($pdfName: String!, $companyName: String!) {
  GetPdfInfo(pdfName: $pdfName, companyName: $companyName) {
    PdfData
    ConsentDate
  }
}
    `;

export function useGetPdfInfoQuery(options: Omit<Urql.UseQueryArgs<GetPdfInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPdfInfoQuery, GetPdfInfoQueryVariables>({ query: GetPdfInfoDocument, ...options });
};
export const GetContractInfoDocument = gql`
    query GetContractInfo($id: String!) {
  GetContractInfo(id: $id) {
    Code
    Message
    Details {
      Symbol
      SymbolName
      ProductType
      ApplicationAmount
      PaymentDate
      AccruedInterest
      TotalTransferFee
      PayeeBankName
      PayeeBankBranchName
      PayeeBankAccountTypeName
      PayeeBankAccount
      PayeeBankAccountHolderName
      PayeeBankAccountHolderNameKana
      Status
      ExpensesTotal
      TransferRequestFormDocumentInfo {
        ID
        FileName
        DisplayName
        IssueDate
      }
      AssignmentAgreementDocumentInfo {
        ID
        FileName
        DisplayName
        IssueDate
      }
      ContractAgreementDocumentInfo {
        ID
        FileName
        DisplayName
        IssueDate
      }
      TransferConsentDocumentInfo {
        ID
        FileName
        DisplayName
        IssueDate
      }
      ContractAgreementDocumentData
    }
  }
}
    `;

export function useGetContractInfoQuery(options: Omit<Urql.UseQueryArgs<GetContractInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContractInfoQuery, GetContractInfoQueryVariables>({ query: GetContractInfoDocument, ...options });
};
export const SignContractDocument = gql`
    mutation SignContract($input: SignContractParam) {
  SignContract(input: $input) {
    Code
    Message
  }
}
    `;

export function useSignContractMutation() {
  return Urql.useMutation<SignContractMutation, SignContractMutationVariables>(SignContractDocument);
};
export const GetAccountInfoDocument = gql`
    query GetAccountInfo {
  GetAccountInfo {
    ...Account
  }
}
    ${AccountFragmentDoc}`;

export function useGetAccountInfoQuery(options?: Omit<Urql.UseQueryArgs<GetAccountInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountInfoQuery, GetAccountInfoQueryVariables>({ query: GetAccountInfoDocument, ...options });
};
export const GetAccountTypeDocument = gql`
    query GetAccountType {
  GetAccountInfo {
    AccountType
  }
}
    `;

export function useGetAccountTypeQuery(options?: Omit<Urql.UseQueryArgs<GetAccountTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountTypeQuery, GetAccountTypeQueryVariables>({ query: GetAccountTypeDocument, ...options });
};
export const GetCompatibleDocument = gql`
    query GetCompatible {
  GetAccountInfo {
    Compatible {
      LeaseFund
      DomesticRealEstate
      OverseasRealEstate
    }
  }
}
    `;

export function useGetCompatibleQuery(options?: Omit<Urql.UseQueryArgs<GetCompatibleQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompatibleQuery, GetCompatibleQueryVariables>({ query: GetCompatibleDocument, ...options });
};
export const GetSendSmsMessageDocument = gql`
    query GetSendSMSMessage {
  GetAccountInfo {
    SendSMSMessage
  }
}
    `;

export function useGetSendSmsMessageQuery(options?: Omit<Urql.UseQueryArgs<GetSendSmsMessageQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSendSmsMessageQuery, GetSendSmsMessageQueryVariables>({ query: GetSendSmsMessageDocument, ...options });
};
export const GetPreApplicationStatusDocument = gql`
    query GetPreApplicationStatus {
  GetAccountInfo {
    ApplicationStatus {
      HasAnsweredDividendAccount
      HasValidFatcaAnswer
      HasAnsweredInvoiceNumber
      HasValidPEPsAnswer
    }
    IsElderly
  }
}
    `;

export function useGetPreApplicationStatusQuery(options?: Omit<Urql.UseQueryArgs<GetPreApplicationStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPreApplicationStatusQuery, GetPreApplicationStatusQueryVariables>({ query: GetPreApplicationStatusDocument, ...options });
};
export const GetAgreementDocumentDocument = gql`
    query GetAgreementDocument {
  GetAgreementDocument {
    Data {
      Read
      Type
      TermsAndConditionsURL
      ComparisonTableURL
      ChangeDetailsURL
    }
  }
}
    `;

export function useGetAgreementDocumentQuery(options?: Omit<Urql.UseQueryArgs<GetAgreementDocumentQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAgreementDocumentQuery, GetAgreementDocumentQueryVariables>({ query: GetAgreementDocumentDocument, ...options });
};
export const AgreeDocumentDocument = gql`
    mutation AgreeDocument($input: AgreeDocumentParam) {
  AgreeDocument(input: $input) {
    Code
    Message
  }
}
    `;

export function useAgreeDocumentMutation() {
  return Urql.useMutation<AgreeDocumentMutation, AgreeDocumentMutationVariables>(AgreeDocumentDocument);
};
export const GetAdvanceQuestionDocument = gql`
    query GetAdvanceQuestion($id: String!) {
  GetAdvanceQuestion(id: $id) {
    HaveEKYCDocument
    DealerMailAddress
    CanTakePicture
    RepresentAndDealerAreSame
    AdvanceNationality
    AdvanceCountryOfResidence
    Birthdate
  }
}
    `;

export function useGetAdvanceQuestionQuery(options: Omit<Urql.UseQueryArgs<GetAdvanceQuestionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAdvanceQuestionQuery, GetAdvanceQuestionQueryVariables>({ query: GetAdvanceQuestionDocument, ...options });
};
export const AdvanceQuestionDocument = gql`
    mutation AdvanceQuestion($input: AdvanceQuestionParam) {
  AdvanceQuestion(input: $input) {
    Code
    Message
  }
}
    `;

export function useAdvanceQuestionMutation() {
  return Urql.useMutation<AdvanceQuestionMutation, AdvanceQuestionMutationVariables>(AdvanceQuestionDocument);
};
export const AgreeDisclosureStatementDocument = gql`
    mutation AgreeDisclosureStatement($input: AgreeDisclosureStatementParam) {
  AgreeDisclosureStatement(input: $input) {
    Code
    Message
  }
}
    `;

export function useAgreeDisclosureStatementMutation() {
  return Urql.useMutation<AgreeDisclosureStatementMutation, AgreeDisclosureStatementMutationVariables>(AgreeDisclosureStatementDocument);
};
export const GetAddressInfoDocument = gql`
    query GetAddressInfo($postCode: String!) {
  GetAddressInfo(postCode: $postCode) {
    CityCountry
    Prefecture
    TownStreetAddress
  }
}
    `;

export function useGetAddressInfoQuery(options: Omit<Urql.UseQueryArgs<GetAddressInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAddressInfoQuery, GetAddressInfoQueryVariables>({ query: GetAddressInfoDocument, ...options });
};
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordParam) {
  ChangePassword(input: $input) {
    Code
    Message
  }
}
    `;

export function useChangePasswordMutation() {
  return Urql.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument);
};
export const OpenAccountDocument = gql`
    mutation OpenAccount($input: OpenAccountParam) {
  OpenAccount(input: $input) {
    Code
    Message
  }
}
    `;

export function useOpenAccountMutation() {
  return Urql.useMutation<OpenAccountMutation, OpenAccountMutationVariables>(OpenAccountDocument);
};
export const ChangeAccountInfoDocument = gql`
    mutation ChangeAccountInfo($input: ChangeAccountInfoParam) {
  ChangeAccountInfo(input: $input) {
    Code
    Message
  }
}
    `;

export function useChangeAccountInfoMutation() {
  return Urql.useMutation<ChangeAccountInfoMutation, ChangeAccountInfoMutationVariables>(ChangeAccountInfoDocument);
};
export const ChangeDomesticRealEstateApplicationDocument = gql`
    mutation ChangeDomesticRealEstateApplication($input: ChangeDomesticRealEstateApplicationParam) {
  ChangeDomesticRealEstateApplication(input: $input) {
    Code
    Message
  }
}
    `;

export function useChangeDomesticRealEstateApplicationMutation() {
  return Urql.useMutation<ChangeDomesticRealEstateApplicationMutation, ChangeDomesticRealEstateApplicationMutationVariables>(ChangeDomesticRealEstateApplicationDocument);
};
export const GetAccountDetailInfoDocument = gql`
    query GetAccountDetailInfo {
  GetAccountDetailInfo {
    RepresentAndDealerAreSame
    CorporateNumber
    Name
    Furigana
    CorporateAddressConfirm
    RegisteredPostCode
    RegisteredPrefecture
    RegisteredCityCountry
    RegisteredTownStreetAddress
    RegisteredBuildingNameAndRoomNumber
    CorporateSettlementMonth
    CorporateSettlementDay
    CorporateEstablishmentDate
    CorporateMainBusinessContent
    CorporateMainBusinessContentOtherText
    CorporateOtherBusinessContent
    CorporateOtherBusinessContentOtherText
    CorporateCapital
    CorporateNumberOfEmployees
    CorporateHomepage
    ElectronicDocumentAgreement
    LeaseFundPurpose
    LeaseFundPurposeOtherText
    DomesticRealEstatePurpose
    DomesticRealEstatePurposeOtherText
    OverseasRealEstatePurpose
    OverseasRealEstatePurposeOtherText
    ContactPhoneNumber
    ContactFaxNumber
    RepresentFirstName
    RepresentLastName
    RepresentFirstNameKana
    RepresentLastNameKana
    RepresentBirthDay
    RepresentPostCode
    RepresentPrefecture
    RepresentCityCountry
    RepresentTownStreetAddress
    RepresentBuildingNameAndRoomNumber
    RepresentMobilePhoneNumber
    RepresentPosition
    RepresentMailAddress
    DealerFirstName
    DealerLastName
    DealerFirstNameKana
    DealerLastNameKana
    DealerBirthDay
    DealerPostCode
    DealerPrefecture
    DealerCityCountry
    DealerTownStreetAddress
    DealerBuildingNameAndRoomNumber
    DealerMobilePhoneNumber
    DealerMailAddress
    DealerDepartment
    DealerOtherDepartment
    DealerPosition
    AboutRuler1
    Ruler1Name
    Ruler1BirthDay
    Ruler1Relationship
    Ruler1MailAddress
    Ruler1PostCode
    Ruler1Prefecture
    Ruler1CityCountry
    Ruler1TownStreetAddress
    Ruler1BuildingNameAndRoomNumber
    Ruler1ImportantPublicWorker
    AboutRuler2
    Ruler2Name
    Ruler2BirthDay
    Ruler2Relationship
    Ruler2MailAddress
    Ruler2PostCode
    Ruler2Prefecture
    Ruler2CityCountry
    Ruler2TownStreetAddress
    Ruler2BuildingNameAndRoomNumber
    Ruler2ImportantPublicWorker
    AboutRuler3
    Ruler3Name
    Ruler3BirthDay
    Ruler3Relationship
    Ruler3MailAddress
    Ruler3PostCode
    Ruler3Prefecture
    Ruler3CityCountry
    Ruler3TownStreetAddress
    Ruler3BuildingNameAndRoomNumber
    Ruler3ImportantPublicWorker
    InvestorCategoryInfo
    ConfirmResponsibility
    TwoFactorAuthenticationType
    InvoiceNumber
    Fatca
    FatcaOtherText
    PostCode
    Prefecture
    CityCountry
    TownStreetAddress
    BuildingNameAndRoomNumber
    Occupation
    OccupationOtherText
    PersonalMainBusinessContent
    PersonalMainBusinessContentOtherText
    PersonalOtherBusinessContent
    PersonalOtherBusinessContentOtherText
    ImportantPublicWorker
    ImportantPublicWorkerOtherReason
    TransferBankName
    TransferBranchName
    TransferAccountType
    TransferAccountNumber
    TransferAccountHolderName
  }
}
    `;

export function useGetAccountDetailInfoQuery(options?: Omit<Urql.UseQueryArgs<GetAccountDetailInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAccountDetailInfoQuery, GetAccountDetailInfoQueryVariables>({ query: GetAccountDetailInfoDocument, ...options });
};
export const GetDateTimeDocument = gql`
    query GetDateTime {
  GetDateTime {
    Current
  }
}
    `;

export function useGetDateTimeQuery(options?: Omit<Urql.UseQueryArgs<GetDateTimeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDateTimeQuery, GetDateTimeQueryVariables>({ query: GetDateTimeDocument, ...options });
};
export const SendPreContractNotifyDocument = gql`
    mutation SendPreContractNotify($input: SendPreContractNotifyParam) {
  SendPreContractNotify(input: $input) {
    Code
    Message
  }
}
    `;

export function useSendPreContractNotifyMutation() {
  return Urql.useMutation<SendPreContractNotifyMutation, SendPreContractNotifyMutationVariables>(SendPreContractNotifyDocument);
};
export const LogoutDocument = gql`
    mutation Logout {
  Logout {
    Code
    Message
  }
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const GetFaqListDocument = gql`
    query GetFaqList($count: Int!, $page: Int!, $symbolProductType: Int!) {
  GetFaqList(count: $count, page: $page, symbolProductType: $symbolProductType) {
    TotalCount
    Data {
      ...FaqListItem
    }
  }
}
    ${FaqListItemFragmentDoc}`;

export function useGetFaqListQuery(options: Omit<Urql.UseQueryArgs<GetFaqListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFaqListQuery, GetFaqListQueryVariables>({ query: GetFaqListDocument, ...options });
};
export const GetFaqContentsListDocument = gql`
    query GetFaqContentsList($count: Int!, $page: Int!, $categoryId: Int!, $symbolProductType: Int!) {
  GetFaqContentsList(
    count: $count
    page: $page
    categoryId: $categoryId
    symbolProductType: $symbolProductType
  ) {
    TotalCount
    Data {
      ...FaqContentsListItem
    }
  }
}
    ${FaqContentsListItemFragmentDoc}`;

export function useGetFaqContentsListQuery(options: Omit<Urql.UseQueryArgs<GetFaqContentsListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFaqContentsListQuery, GetFaqContentsListQueryVariables>({ query: GetFaqContentsListDocument, ...options });
};
export const GetBrokerInfoDocument = gql`
    query GetBrokerInfo($brokerName: String, $brokerCode: String) {
  GetBrokerInfo(brokerCode: $brokerCode, brokerName: $brokerName) {
    TotalCount
    Data {
      ...BrokerListItem
    }
  }
}
    ${BrokerListItemFragmentDoc}`;

export function useGetBrokerInfoQuery(options?: Omit<Urql.UseQueryArgs<GetBrokerInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrokerInfoQuery, GetBrokerInfoQueryVariables>({ query: GetBrokerInfoDocument, ...options });
};
export const GetBrokerBranchInfoDocument = gql`
    query GetBrokerBranchInfo($brokerName: String, $branchCode: String, $branchName: String) {
  GetBrokerBranchInfo(
    brokerName: $brokerName
    branchCode: $branchCode
    branchName: $branchName
  ) {
    TotalCount
    Data {
      ...BrokerListItem
    }
  }
}
    ${BrokerListItemFragmentDoc}`;

export function useGetBrokerBranchInfoQuery(options?: Omit<Urql.UseQueryArgs<GetBrokerBranchInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBrokerBranchInfoQuery, GetBrokerBranchInfoQueryVariables>({ query: GetBrokerBranchInfoDocument, ...options });
};